<template>
<div>
  <div class="wrap" @click="hideDropdown($event), hideKeywordDropdown()">
    <div class="loading_gif" v-show="loading" style="position: fixed;max-width: 640px">
      <img src="../../../static/images/loading.gif" class="loading-img">
      <p style="font-size:14px;color: #FFFFFF;">文件较大,请稍等...</p>
    </div>

    <div class="wrapper" v-show="!showCompanyDetailWrap && !smartEngine.open">
      <!--统计-->
      <div class="stat-analyze" v-show="showTongjiPage && !showSearchPage && !showResultPage">
        <div class="search-header">
          <div class="search-header-text" @click="switchPage(2), setCnzz('[Mobile]-深度搜索', '从统计页返回搜索结果页', '')">
            <span class="arrow-back"></span>统计
          </div>
        </div>
        <div class="search-header-menu statis">
          <ul>
            <li @click="showStatAnalyze = true, showStatFilter = false, setCnzz('[Mobile]-深度搜索', '点击分析按钮', '')" :class="{on: showStatAnalyze}">分析</li>
            <li @click="showStatAnalyze = false, showStatFilter = true, setCnzz('[Mobile]-深度搜索', '点击筛选按钮', '')" :class="{on: showStatFilter}">筛选</li>
          </ul>
        </div>

        <!--分析-->
        <div class="Analysis-list" v-show="showStatAnalyze">
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">相关的公司</span>
            <ul>
              <li v-for="item in company"> {{ item.key }} </li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">提到的公司</span>
            <ul>
              <li v-for="item in related_company">{{ item.key }}</li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">相关人员</span>
            <ul>
              <li v-for="item in related_name">{{ item.key }}</li>
            </ul>
          </div>

          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">相关的公司</span>
            <ul>
              <li v-for="item in company"> {{ item.key }} </li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">提到的公司</span>
            <ul>
              <li v-for="item in related_company">{{ item.key }}</li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">相关人员</span>
            <ul>
              <li v-for="item in related_name">{{ item.key }}</li>
            </ul>
          </div>
        </div>

        <!--筛选-->
        <div class="Analysis-list" v-show="showStatFilter && searched===stype">
          <div class="Analysis-list-box" v-show="aggLabels.length>0">
            <span class="head">公告标签</span>
            <ul>
              <li v-for="d in aggLabels">
                <label class="el-checkbox mar" style="width: 74%;">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['labels'][d.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('labels', d)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox">
                  </span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('labels', d)">{{d.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">{{d.count}}</span>
              </li>
            </ul>
          </div>
          <div class="Analysis-list-box" v-show="aggTypes.length>0">
            <span class="head">公告类型</span>
            <ul>
              <li v-for="type in aggTypes">
                <label class="el-checkbox mar" style="width: 74%;">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['type'][type.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('type', type)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox"></span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('type', type)">{{type.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">
                  {{type.count}}
                </span>
              </li>
            </ul>
          </div>
          <div class="Analysis-list-box" v-show="aggPlates.length>0">
            <span class="head">板块类型</span>
            <ul>
              <li v-for="plate in aggPlates">
                <label class="el-checkbox mar" style="width: 74%;">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['plate'][plate.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('plate', plate)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox"></span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('plate', plate)">{{plate.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">
                  {{plate.count}}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!--搜索条件-->
      <div class="search-conditions" v-show="!showTongjiPage && showSearchPage && !showResultPage">
        <div class="search-header">
          <div class="search-header-text" @click.stop="switchPage(2),  setCnzz('[Mobile]-深度搜索', '从搜索条件页返回搜索结果页', '')">
            <span class="arrow-back"></span>搜索条件
          </div>
          <span class="search-header-stics" @click="showModalTag = true">保存标签</span>
        </div>

        <div class="cont-wrap">
          <div class="Depth-list">
            <!--板块类型-->
            <div class="Depth-list-box">
              <div class="head"> 搜索类型 </div>
              <div class="content"> {{tab1 | formatTab1}} </div>
            </div>
            <!--板块-->
            <div class="Depth-list-box">
              <div class="head"> 板块 </div>
              <div class="content"> {{stype | stypename}} </div>
            </div>

            <template v-for="item in searchCondition">
              <!--板块类型-->
              <template v-if="item.name === '板块类型'">
                <div class="Depth-list-box">
                  <div class="head"> 板块类型 </div>
                  <div class="content">
                    <span :class="{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}">{{item.child[0].op | opname}}</span>
                    <span v-for="c in item.child" style="margin-right: 5px">
                      <span v-for="i in c.value" style="margin-right: 5px">{{i.name}}</span>
                    </span>
                  </div>
                </div>
              </template>

              <!--公告标签-->
              <template v-if="item.name === '公告标签'">
                <div class="Depth-list-box">
                  <div class="head"> 公告标签 </div>
                  <div class="content">
                    <span :class="{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}">{{item.child[0].op | opname}}</span>
                    <span class="right" v-for="c in item.child">
                      <span v-for="i in c.value" style="margin-right: 5px">{{i.name}}</span>
                    </span>
                  </div>
                </div>
              </template>

              <!--发布日期-->
              <template v-if="item.name === '发布日期'">
                <div class="Depth-list-box">
                  <div class="head"> 发布日期 </div>
                  <div class="content">
                    <span v-for="c in item.child">{{c.name}}</span>
                  </div>
                </div>
              </template>

              <!--公告类型-->
              <template v-if="item.name === '公告类型'">
                <div class="Depth-list-box">
                  <div class="head"> 公告类型 </div>
                  <div class="content">
                    <span :class="{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}"> {{item.child[0].op | opname}}</span>
                    <span class="right" v-for="c in item.child">
                      <span v-for="i in c.value" style="margin-right: 5px">{{i.name}}</span>
                    </span>
                  </div>
                </div>
              </template>

              <!--转让类型-->
              <template v-if="item.name === '转让类型'">
                <div class="Depth-list-box">
                  <div class="head"> 转让类型 </div>
                  <div class="content">
                    <span v-for="c in item.child" style="margin-right: 5px">{{c.name}}</span>
                  </div>
                </div>
              </template>

              <!--搜索范围-->
              <template v-if="item.name === '搜索范围'">
                <div class="Depth-list-box">
                  <div class="head">搜索范围</div>
                  <div class="con-search">
                    <ul>
                      <li v-if="ssfw.zj.zjzw.length !== 0 || ssfw.zj.zjbt.length !== 0">
                        <div class="depth-header blue">章节</div>
                        <ul class="two">
                          <li v-if="ssfw.zj.zjzw && ssfw.zj.zjzw.length !== 0">
                            <div class="l"><div class="mline-one"></div></div>
                            <div class="depth-header blue">章节正文</div>
                            <ul class="two">
                              <li>
                                <ul class="two">
                                  <div class="line">
                                    <div class="line-a">
                                      <div class="mline-a1"></div>
                                    </div>
                                    <div class="mline-a2"></div>
                                  </div>
                                  <template v-for="(index, cc) in ssfw.zj.zjzw">
                                    <li v-if="index !== 0"><div class="l"> <div class="mline-a3"></div> </div></li>
                                    <li>
                                      <span :class="{'title': true,  'not-b': cc.op == 3, 'not-c': cc.op == 1, 'not-a': cc.op == 2}">{{cc.op | formatSSFW }}</span>{{cc.value}}
                                    </li>
                                  </template>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          <li v-if="ssfw.zj.zjbt && ssfw.zj.zjbt.length !== 0">
                            <div class="l"><div class="mline-one"></div></div>
                            <div class="depth-header blue">章节标题</div>
                            <ul class="two">
                              <li>
                                <ul class="two">
                                  <div class="line">
                                    <div class="line-a">
                                      <div class="mline-a1"></div>
                                    </div>
                                    <div class="mline-a2"></div>
                                  </div>
                                  <template v-for="(index, cc) in ssfw.zj.zjbt">
                                    <li v-if="index !== 0"><div class="l"> <div class="mline-a3"></div> </div></li>
                                    <li><span :class="{'title': true,  'not-b': cc.op == 3, 'not-c': cc.op == 1, 'not-a': cc.op == 2}">{{cc.op | formatSSFW }}</span>{{cc.value}}</li>
                                  </template>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>

                      <li v-if="ssfw.all && ssfw.all.length !== 0">
                        <div class="l"><div class="mline-one"></div></div>
                        <div class="depth-header blue">全部</div>
                        <ul class="two">
                          <div class="line">
                            <div class="line-a">
                              <div class="mline-a1"></div>
                            </div>
                            <div class="mline-a2"></div>
                          </div>
                          <template v-for="(index, cc) in ssfw.all">
                            <li v-if="index !== 0"><div class="l"> <div class="mline-a3"></div> </div></li>
                            <li><span :class="{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}"> {{cc.op | formatSSFW }} </span>{{cc.value}}</li>
                          </template>
                        </ul>
                      </li>
                      <li v-if="ssfw.zw && ssfw.zw.length !== 0">
                        <div class="l"><div class="mline-one"></div></div>
                        <div class="depth-header blue">正文</div>
                        <ul class="two">
                          <div class="line">
                            <div class="line-a">
                              <div class="mline-a1"></div>
                            </div>
                            <div class="mline-a2"></div>
                          </div>
                          <template v-for="(index, zw) in ssfw.zw">
                            <li v-if="index !== 0"><div class="l"> <div class="mline-a3"></div> </div></li>
                            <li><span :class="{'title': true,  'not-b': zw.op == 3, 'not-c': zw.op == 1, 'not-a': zw.op == 2}"> {{zw.op | formatSSFW }} </span>{{zw.value}}</li>
                          </template>
                        </ul>
                      </li>
                      <li v-if="ssfw.ggbt && ssfw.ggbt.length !== 0">
                        <div class="l"><div class="mline-one"></div></div>
                        <div class="depth-header blue">公告标题</div>
                        <ul class="two">
                          <div class="line">
                            <div class="line-a">
                              <div class="mline-a1"></div>
                            </div>
                            <div class="mline-a2"></div>
                          </div>
                          <template v-for="(index, item) in ssfw.ggbt">
                            <li v-if="index !== 0"><div class="l"> <div class="mline-a3"></div> </div></li>
                            <li><span :class="{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}"> {{item.op | formatSSFW }} </span>{{item.value}}</li>
                          </template>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>

              <!--公司-->
              <template v-if="item.name === '公司'">
                <!-- 基本信息 -->
                <template v-if="!isEmpty(gs.jbxx)">
                  <div class="Depth-list-box" style="width: 91%">
                    <div class="head"> 公司基本信息 </div>
                    <div class="con-search" style="padding-top: 0">
                      <ul>
                        <li v-for="cc in gs.jbxx" v-if="cc.length !== 0">
                          <div class="l"><div class="mline-one"></div> </div>
                          <div class="depth-header blue">{{cc[0].name}}</div>
                          <ul class="two">
                            <div class="line">
                              <div class="line-a">
                                <div class="mline-a1"></div>
                              </div>
                              <div class="mline-a2"></div>
                            </div>
                            <li>
                              <template v-if="cc[0].code === 'industry'">
                                <template v-for="(index, item) in cc">
                                  <li v-if="index !== 0" style="padding-left: 0"><div class="l"> <div class="mline-a3"></div></div></li>
                                  <li>
                                    <span :class="{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}">
                                    {{item.child[0].op | formatSSFW }}
                                    </span>
                                    <span v-for="v in item.child[0].value" style="margin-right: 5px"> {{v.name}} </span>
                                  </li>
                                </template>
                              </template>

                              <template v-if="cc[0].code === 'region'">
                                <template v-for="(index, item) in cc">
                                  <li v-if="index !== 0" style="padding-left: 0"><div class="l"> <div class="mline-a3"></div></div></li>
                                  <li>
                                    <span :class="{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}">
                                    {{item.child[0].op | formatSSFW }}
                                    </span>
                                    <span v-for="v in item.child[0].value" style="margin-right: 5px"> {{v.name}} </span>
                                  </li>
                                </template>
                              </template>

                              <template v-if="cc[0].code !== 'industry' && cc[0].code !== 'region'">
                                <template v-for="(index, item) in cc">
                                  <li v-if="index !== 0" style="padding-left: .5rem"><div class="l"> <div class="mline-a3"></div> </div></li>
                                  <li><span :class="{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}"> {{item.op | formatSSFW }} </span>{{item.value}}</li>
                                <!--   <template v-if="item.range !== 3">
                                    <template v-if="item.name !== '地区' && item.name !== '行业类型'">
                                      <span>{{item.value}}</span>
                                    </template>

                                    <template v-if="item.name === '地区' || item.name === '行业类型'">
                                      <span v-for="ccc in item.child">
                                        <span v-for="v in ccc.value" style="margin-right: 5px">
                                           {{v.name}}
                                        </span>
                                      </span>
                                    </template>

                                    <span v-if="item.name === '注册资本'">（万元）</span>
                                    <span v-if="!item.name === '注册资本'"></span>
                                  </template>
                                  <template v-if="item.range === 3">
                                    <span>{{item.value}} ~ {{item.value1}}</span>
                                    <span v-if="item.name === '注册资本'">（万元）</span>
                                    <span v-if="!item.name === '注册资本'"></span>
                                  </template> -->
                                </template>
                              </template>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>

                <!-- 财务数据 -->
                <template v-if="!isEmpty(gs.cwsj.cwzb) || !isEmpty(gs.cwsj.gjbl)">
                  <div class="Depth-list-box" style="width: 91%">
                    <div class="head"> 公司财务数据 </div>
                    <div class="con-search" style="padding-top: 0">
                      <ul style="width: 93%; margin-left: 10px">
                        <!-- 财务指标 -->
                        <!-- <li> -->
                        <li v-if="!isEmpty(gs.cwsj.cwzb)">
                          <div class="l"><div class="mline-one"></div> </div>
                          <div class="depth-header blue" style="font-size: 15px">财务指标</div>
                          <ul class="two" style="margin-left: 10px">
                            <li v-for="c in gs.cwsj.cwzb">
                              <template v-for="(index, item) in c">
                                <div class="mline-two"></div>
                                <div class="depth-header">{{item.name}}</div>
                                <ul class="two" style="width: 97%">
                                  <div class="line">
                                    <div class="line-a">
                                      <div class="mline-a1"></div>
                                    </div>
                                    <div class="mline-a2"></div>
                                  </div>
                                  <li>
                                      <li v-if="index !== 0" style="padding-left: 0"><div class="l"> <div class="mline-a3"></div></div></li>
                                      <li>
                                        <span class="title not-c"> {{item.year}} </span>
                                        <span class="title not-a"> {{item.quarter}} </span>
                                        <span class="title not-a"> {{item.range | formatRangeToName}} </span>
                                          <template v-if="item.range !== 3">
                                          <span>{{item.value}}</span>
                                          <span>（元）</span>
                                        </template>
                                        <template v-if="item.range === 3">
                                          <span>{{item.value}} ~ {{item.value1}}</span>
                                          <span>（元）</span>
                                        </template>
                                      </li>
                                  </li>
                                </ul>
                              </template>
                            </li>
                          </ul>
                        </li>
                        <!-- 关键比率 -->
                        <li v-if="!isEmpty(gs.cwsj.gjbl)">
                          <div class="l"><div class="mline-one"></div> </div>
                          <div class="depth-header blue" style="font-size: 15px">关键比率</div>
                          <ul class="two" style="margin-left: 10px">
                            <li v-for="c in gs.cwsj.gjbl" v-if="c.length !== 0">
                              <div class="mline-two"></div>
                              <div class="depth-header">{{c[0].name}}</div>
                              <ul class="two" style="width: 97%">
                                <div class="line">
                                  <div class="line-a">
                                    <div class="mline-a1"></div>
                                  </div>
                                  <div class="mline-a2"></div>
                                </div>
                                <li>
                                  <template v-for="(index, item) in c">
                                    <li v-if="index !== 0" style="padding-left: 0"><div class="l"> <div class="mline-a3"></div></div></li>
                                    <li>
                                      <span class="title not-c"> {{item.year}} </span>
                                      <span class="title not-a"> {{item.quarter}} </span>
                                      <span class="title not-a"> {{item.range | formatRangeToName}} </span>
                                      <template v-if="item.range !== 3">
                                        <span>{{item.value}}</span>
                                        <span v-if="item.name === '资产负债率' || item.name === '毛利率' || item.name === '净利率' || item.name === '净资产收益率'">（%）</span>
                                        <span v-if="item.name === '流动比率' || item.name === '速动比率' ">（倍）</span>
                                        <span v-if="item.name === '存货周转率'">（次）</span>
                                        <span v-if="item.name === '每股净资产'">（元）</span>
                                        <span v-if="item.name === '每股经营活动产生的现金流量净额'">（元/股）</span>
                                      </template>
                                      <template v-if="item.range === 3">
                                        <span>{{item.value}} ~ {{item.value1}}</span>
                                        <span v-if="item.name === '资产负债率' || item.name === '毛利率' || item.name === '净利率' || item.name === '净资产收益率'">（%）</span>
                                        <span v-if="item.name === '流动比率' || item.name === '速动比率' ">（倍）</span>
                                        <span v-if="item.name === '存货周转率'">（次）</span>
                                        <span v-if="item.name === '每股净资产'">（元）</span>
                                        <span v-if="item.name === '每股净资产'">（元）</span>
                                        <span v-if="item.name === '每股经营活动产生的现金流量净额'">（元/股）</span>
                                      </template>
                                    </li>
                                 </template>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </template>
              <!--/公司-->

            </template>
          </div>
        </div>
      </div>

      <div class="my-container" v-show="showComments" style="top: 0px;position:static;background-color:white;">
        <div class="comment-detail">
          <div class="comment-title">
           <p class="comment-all">全部评论</p> <!-- <a class="comment-my" href="javascript:;">我的评论</a>  -->
           <p class="comment-sort">{{cpwtotal}}条评论</p>
          </div>
          <div class="comment" v-for="item in commentList">
            <div class="common-avatar">
            <img src="/static/images/user.png" width="100%" height="100%">

          </div>
          <div class="comment-block">
            <p class="comment-user">
              <span class="comment-username" v-if="item.user"> {{item.user.username}} </span>
              <span class="comment-username" v-else> 匿名用户 </span>
            <span class="footer-zan"> <i class="c-share-icon" @click.stop="zan(item.id, $event)"></i><span class="u-num">{{item.zan_cnt}}</span></span>
            </p>
             <div class="comment-content">{{item.content}}
             </div>
             <div class="comment-operate">
                <span class="J_Vote comment-operate-item comment-operate-up">{{item.updtime | date}}</span>
                <span class="J_Reply comment-operate-item"> <a href="javascript:;" @click="commentinput = true, pid = item.id, content = ''">回复</a> </span>
            </div>
            <div class="comment-reply-ctn comment-reply-item" >
              <ul>
                <li v-for="i in item.replys" track-by="$index" v-if="$index < item.showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="i.user"> {{i.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{i.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up"><i class="c-share-icon" @click.stop="zan(i.id, $event)"></i><span>{{i.zan_cnt}}</span></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{i.updtime | date}}</span>
                    </div>
                </li>
                <!-- <li v-for="y in item.replys" track-by="$index" v-if="showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="y.user"> {{y.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{y.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up">赞<i class="staticAdd" @click.stop="zan(i.id, $event)">{{i.zan_cnt}}</i></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{y.updtime | date}}</span>
                    </div>
                </li> -->

                <li class="view-more hidden" v-if="item.replys.length > 2 && item.showall !== 8">
                  <a class="btn-block text-center btn-comment-expand" @click="item.showall = 8">查看全部<span class="nume">{{item.replys.length}}</span>条回复  </a>
                </li>
              </ul>
              </div>
          </div>
          </div>
          </div>

          <div class="comment-more">
          <a href="javascript:;" v-if="commentList.length !== cpwtotal">加载更多评论中...</a>
          <a href="javascript:;" v-if="commentList.length == cpwtotal && cpwtotal !== 0">评论已全部加载</a>
          </div>
          <div class="comment-no" v-if="cpwtotal == 0">
          暂无评论，快来添加一个吧！
          </div>
          <div class="comment-no"></div>
        </div>

      <!--搜索结果-->
      <div class="result-container" id="result-container" v-show="!showTongjiPage && !showSearchPage && showResultPage && !showComments">
        <template v-if="topPage == 1">
          <div class="search-header">
            <div class="search-header-text">
              <span>{{stype | formatTypeName}}</span>
            </div>
            <span class="search-header-stics" v-if="tab1 === 1" @click="switchPage(3), showStatAnalyze = true,  setCnzz('[Mobile]-深度搜索', '进入统计页', '')">统计</span>
            <span class="search-header-stics" @click="showModalTag = true">保存标签</span>
          </div>

          <div class="screen-menu" v-if="tab1 == 1">
            <div class="Depth-date">
              <div @click.stop="slideToggle('sort')">
                {{ sort==1?'按相关性排序':'按时间排序' }}
                <span class="close-bot"></span>
              </div>
              <ul class="date-menu" v-show="showDropdownMenu == 'sort'" @click="hideDropdown">
                <li><a href="javascript:;" @click="selSort(1),  setCnzz('[Mobile]-深度搜索', '点击按相关性排序按钮', '')">按相关性排序</a></li>
                <li><a href="javascript:;" @click="selSort(2), setCnzz('[Mobile]-深度搜索', '点击按时间排序按钮', '')">按时间排序</a></li>
              </ul>
            </div>
          </div>

          <div class="Screen-criteria" v-if="tags1.length > 0 && tab1 == 1">
            <div class="Screen-criteria-head" @click="showtag = !showtag, slideToggleTag()">
              <span class="fl">我的标签</span>
              <span class="fr" v-if="showtag"></span>
              <span class="f3" v-if="!showtag"></span>
            </div>
            <div class="Screen-criteria-box cpwtag" style="display:none;">
              <ul>
                <li v-for="item in tags1" @click="searchByTag(item.id), showtag = false, slideToggleTag()">
                  <span class="notice-left">{{item.name}}</span>
                  <span class="notice-right" @click.stop="delTag(item.id)"></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="Screen-criteria" v-if="tags2.length > 0 && tab1 == 2">
            <div class="Screen-criteria-head" @click="showtag = !showtag, slideToggleTag()">
              <span class="fl">我的标签</span>
              <span class="fr" v-if="showtag"></span>
              <span class="f3" v-if="!showtag"></span>
            </div>
            <div class="Screen-criteria-box cpwtag" style="display:none;">
              <ul>
                <li v-for="item in tags2" @click="searchByTag(item.id), showtag = false, slideToggleTag()">
                  <span class="notice-left">{{item.name}}</span>
                  <span class="notice-right" @click.stop="delTag(item.id)"></span>
                </li>
              </ul>
            </div>
          </div>

          <!--go搜索条件-->
          <div class="search-criteria" @click.stop="switchPage(1), setCnzz('[Mobile]-深度搜索', '查看搜索条件', '')">
            <span class="fl">搜索条件</span>
            <span class="fr"></span>
          </div>

          <template v-if="havelabels && tab1 === 1">
            <!--筛选条件-->
            <div class="Screen-criteria">
              <div class="Screen-criteria-head" @click.stop="slideDropdownMenu($event)">
                <span class="fl">筛选条件</span>
                <span class="fr close"></span>
              </div>
              <div class="Screen-criteria-box" style="display: none;">
                <ul>
                  <template v-for="(type, obj) in conditions">
                    <!--类型-title-->
                    <li v-if="!isEmptyObj(obj) && type !== 'industry' && type !== 'industrysecond' && type !=='layer' && type !== 'plate'">
                      <span class="selected-icon"></span>
                      <a class="blue">{{ cond_type[type] }}</a>
                    </li>
                    <!--text-->
                    <template v-for="(code, name) in obj" v-if="type !== 'industry' && type !== 'industrysecond' && type !=='layer' && type !== 'plate'">
                      <li>
                        <a class="text-a">{{ name }} </a>
                        <span aria-hidden="true" class="search-icon small-delete" @click="rmvCondition(type, code)"></span>
                      </li>
                    </template>
                  </template>

                  <!--板块类型-->
                  <li v-if="showPla">
                    <span class="selected-icon"></span>
                    <a class="blue">{{cond_type['plate']}}</a>
                  </li>
                  <li v-for="(idx, item) in pageshowConditions['plate']" v-if="idx !== '挂牌公司' && item">
                    <a class="text-a">{{item}}</a>
                    <span aria-hidden="true" class="search-icon small-delete" @click="rmvCondition('plate', idx)"></span>
                  </li>
                  <li class="active" v-if="pageshowConditions['plate']['挂牌公司'].length > 0">
                    <span class="selected-icon"></span>
                    <a class="text-b">挂牌公司</a>
                    <span aria-hidden="true" class="search-icon small-delete" @click="rmvCondition('N3BGP', 'N3BGP')"></span>
                  </li>
                  <li v-for="i in pageshowConditions['plate']['挂牌公司']" v-if="pageshowConditions['plate']['挂牌公司'].length > 0">
                    <a class="text-a">{{i}}</a>
                    <span aria-hidden="true" class="search-icon small-delete" @click="rmvCondition('layer', i)"></span>
                  </li>

                  <!--行业分类-->
                  <li v-if="showInd">
                    <span class="selected-icon"></span>
                    <a class="blue">{{cond_type['industry']}}</a>
                  </li>
                  <template v-for="(type, obj) in pageshowConditions['industry']" v-if="obj.length > 0 || type == 'S综合'">
                    <li class="active">
                      <span class="selected-icon"></span>
                      <a class="text-b">{{type}}</a>
                      <span class="search-icon small-delete" @click="rmvCondition('industry', type.substr(0,1))"></span>
                    </li>
                    <li v-for="item in obj" v-if="obj.length !== industry">
                      <a class="text-a">{{item}}</a>
                      <span class="search-icon small-delete" @click="rmvCondition('industrysecond', item.substr(0, 3))"></span>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </template>

          <!-- 智能引擎 -->
          <div class="intelligent-search-main">
            <div class="intelligent-search" v-if="smartComInfo.shortname && smartComInfo.code">
              <div class="intelligent-heading" style="cursor:pointer;">
                <span class="big-h" @click="goCompanyInfo(smartComInfo.code), setCnzz('信披搜索', '进入公司详情', '')">{{smartComInfo.shortname}}【{{smartComInfo.code}}】</span>
              </div>
              <div class="op-stockdynamic" v-if="smartComInfo.price">
                <div class="op-stockdynamic-top" :class="{'plus': upanddown.indexOf('+') === 0, 'reduce': upanddown.indexOf('-') === 0}">
                  <span class="op-cur-num">{{prices.trade}}元</span>
                  <span class="op-cur-info">{{upanddown}}({{Amplitude}}%)</span>
                </div>
                <div class="op-stockdynamic-bot">
                  <!-- <ul>
                    <li>今日开盘：{{prices.open}}元  今日最高：{{prices.high}}元</li>
                    <li>昨日收盘：{{prices.yesclose}}元  今日最低：{{prices.low}}元</li>
                    <li>今日成交量：<template v-if="prices.volume < 100000">{{prices.volume}}手</template>
                      <template v-if="prices.volume > 100000 || prices.volume == 100000">{{(prices.volume/ 10000).toFixed(1)}}万手</template>
                    </li>
                  </ul> -->
                   <ul class="op-clear">
                    <li>昨收：{{prices.settlement}}</li>
                    <li>今开：{{prices.open}}</li>
                    <li>最高：{{prices.high}}</li>
                    <li>最低：{{prices.low}}</li>
                  </ul>
                  <ul class="op-clear">
                    <li>成交量：<template v-if="prices.volume < 1000000">{{prices.volume}}手</template>
                        <template v-if="prices.volume > 1000000 || prices.volume == 1000000">{{(prices.volume/ 1000000).toFixed(2) | thousands}}万手</template></li>
                    <li>成交额：{{(prices.amount/ 100000000).toFixed(2) | thousands}}亿元</li>
                    <li>总市值：{{(prices.mktcap/10000).toFixed(2) | thousands}}亿元</li>
                    <li>流通市值：{{(prices.nmc/10000).toFixed(2) | thousands}}亿元</li>
                  </ul>
                  <ul class="op-clear">
                    <li>换手率：{{prices.turnoverratio.toFixed(2)}}%</li>
                    <li>市净率：{{prices.pb.toFixed(2)}}</li>
                    <li>振  幅：{{prices.changepercent.toFixed(2)}}%</li>
                    <li>市盈率：{{prices.per.toFixed(2)}}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="intelligent-search" v-if="smartComInfo.finance && smartComInfo.finance.length > 0">
              <div class="intelligent-heading">
                {{smartComInfo.shortname}}【{{smartComInfo.code}}】财务信息
              </div>
              <div class="table-result-outter">
              <ul class="personnel">
                <li :class="{'active': timetyp === 1}" @click="timetyp = 1, setCnzz('[Mobile]深度搜索', '智能引擎——切换为按季度', '')">按季度</li>
                <li :class="{'active': timetyp === 2}" @click="timetyp = 2, setCnzz('[MObile]深度搜索', '智能引擎——切换为按年度', '')">按年度</li>
              </ul>
               <div style="margin-bottom: 20px;">
                <table class="table-result" cellpadding="0">
                  <tbody v-if="timetyp === 1">
                    <!-- <tr class="title"><td v-for="i in finance[0]">{{i}}</td></tr> -->
                    <tr class="title">
                      <td>日期</td>
                      <td>{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td>
                    </tr>
                    <tr v-if="$index > 0 && $index < 6" v-for="item in finance" track-by="$index" :class="{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }">
                      <td v-for="(k,i) in item">
                        <template v-if="k === 0">{{i}}</template>
                        <template v-if="k !== 0">{{i['营业收入'] | thousands}}</template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="timetyp === 2">
                    <tr class="title">
                      <!-- <td v-for="i in yearfinance[0]">{{i}}</td> -->
                      <td>日期</td>
                      <td>{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td>
                    </tr>
                    <tr v-if="$index > 0 && $index < 6" v-for="item in yearfinance" track-by="$index" :class="{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }">
                      <td v-for="(k,i) in item">
                        <template v-if="k === 0">{{i}}</template>
                        <template v-if="k !== 0">{{i['营业收入'] | thousands}}</template>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!--搜索结果-->
        <div class="search-result-box">
          <template v-if="tab1 === 1">
            <div class="anwer-cont"  v-show="searched==stype && items.length==0">
              <div class="no">很抱歉，没有找到相关的结果!</div>
            </div>
          </template>
          <template v-if="tab1 === 2">
            <div class="anwer-cont"  v-show="searched==stype && companylist.length==0 && !loading">
              <div class="no">很抱歉，没有找到相关的结果!</div>
            </div>
          </template>
          <div class="more_top" v-show="!loading && topPage !== 1 && total !== 0" style="margin-bottom: -0.4rem;">
            <i class="pull_icon_top loading"></i>
            <span style="font-size: 15px;">加载中...</span>
          </div>
          <!--公告-->
          <div v-show="tab1 === 1 && searched==stype && detailLists.length>0" id="my-result-wrap">
            <template v-if="stype!=5">
              <div class="search-result-list" v-for="item in detailLists" track-by="$index">
                <p class="head">
                  <span class="{{ fileIcon(item.fileext) }}"></span>
                  <a v-if="stype!=5" style="cursor:pointer;"  @click="checkLogin(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                  <a v-if="stype==5" style="cursor:pointer;" @click="checkLoginQa(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                </p>
                <p class="Subtitle">
                  {{ item.publishDate ? item.publishDate: item.uploadTime }}
                  <span class="marginlf-10">{{ item.companyCode }}</span>
                  <span class="marginlf-10" v-if="item.author">作者: {{ item.author }}</span>
                  <span class="marginlf-10" v-if="item.nickname">公众号: {{ item.nickname }}</span>
                </p>
                <p class="lien" v-if="item.content && item.content!='NoContent' && onlyTitle == 0">
                  {{{ item.content.join('...... ') }}}
                </p>
                <template v-if="item.child && onlyTitle == 0">
                  <template v-for="child in item.child">
                    <!-- <p class="blak font-weight lien">{{{ child.title }}}</p> -->
                    <p class="blak font-weight lien" @click="viewChildTitle(item, child.code)" style="cursor:pointer;">
                      {{{ child.title }}}
                    </p>
                    <p class="lien" v-if="child.content">
                      {{{ child.content.join('...... ') }}}
                    </p>
                    <template v-if="child.contents">
                      <template v-for="c in child.contents">
                        <p class="lien" v-if="c.htmltag=='p'">
                          {{{ c.content }}}</br>
                        </p>
                        <template  v-if="c.htmltag=='table'">
                          <div class="table-result-outter">
                            <table cellpadding="0" class="table-result">
                              <tbody>
                              <tr v-for="(rowidx, row) in c.table" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                                <td v-for="(colidx, col) in row" rowspan="{{ col.row }}" colspan="{{ col.col }}" track-by="$index"> {{{col.value}}} </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="table-whole">
                            <a href="javascript:;" @click="viewTable(item, child.code, c.offset), setCnzz('[Mobile]-深度搜索', '查看表格全部内容', '')">
                              <span class="table-see-icon "></span>查看表格全部内容
                            </a>
                          </div>
                        </template>
                      </template>
                    </template>


                    <!-- 研报图表 -->
                    <div class="intelligent-fsearch-cont" v-if="child.imgs">
                      <template  v-for="c in child.imgs">
                        <div class="fsearch-a">

                          <div class="more-img" style="cursor:pointer;" title="点击查看更多" @click="setBigImgObj(c, item)">
                            <img :src="c.imgurl">
                          </div>
                          <div class="text-a">{{{child.title}}}</div>
                          <div class="text-b" style="cursor:pointer;" @click="viewImg(item, child.code, c.offset)">{{{c.imghead}}}</div>
                          <div class="text-b" style="cursor:pointer;" @click="viewImg(item, child.code, c.offset)">{{{c.imgfoot}}}</div>
                        </div>
                      </template>
                    </div><!-- /研报图表 -->
                  </template>
                </template>

              </div>
            </template>
            <template v-if="stype==5">
              <div class="search-result-list" v-for="item in detailLists" track-by="$index">
                <p class="head">
                  <a class="green" style="cursor:pointer;" @click="checkLoginQa(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')">{{{ item.fulltitle }}}</a>
                </p>
                <p class="Subtitle">{{ item.publishDate ? item.publishDate: item.uploadTime }}</p>
                <p class="lien" v-if="item.content && item.content!='NoContent'">{{{ item.content.join('...... ') }}}</p>
                <template v-if="item.child">
                  <template v-for="child in item.child" >
                    <div v-if="child.content" class="rb odd res-qa-title-wrap" style="overflow: hidden">
                      <div class="res-qa-item-l">
                        <!--新加-->
                      </div>
                      <div style="float: left;" class="res-qa-item-r">
                        <p class="blak font-weight lien" >{{{ child.title }}}</p>
                        <p class="lien" v-if="child.content">
                          {{{ child.content.join('...... ') }}}
                        </p>
                      </div>
                    </div>
                    <div v-if="child.que" class="rb odd res-qa-middle-wrap">
                      <div class="res-qa-item-l">
                        <div class="ques-l"><span class="qicon ques_1" style="margin: 0.1rem 5px 2px 0px;"></span></div>
                      </div>
                      <div class="res-qa-item-r">
                        <p class="lien" v-if="!child.showque">
                          {{{ child.shortque?child.shortque:child.que | maxlen 100 }}}
                          <span class="qust-more blue" @click="child.showque=true" v-if="child.que.length>100"> 展开更多<span class="triangle-bottom"></span></span>
                        </p>
                        <p class="lien" v-if="child.showque">
                          {{{ child.que }}}
                          <span class="qust-stop red" @click="child.showque=false"> 收起<span class="triangle-head"></span></span>
                        </p>
                        <div class="quest-blue">
                          <li v-for="t in child.tag"><a href="javascript:;">{{ t }}</a></li>
                        </div>
                      </div>
                    </div>
                    <div v-if="child.answers" v-for="ans in child.answers" class="res-qa-ans-wrap">
                      <div class="res-qa-item-l">
                        <div class="ques-l">
                          <span class="qicon ques_2" style="margin: 0.12rem 5px 2px 0px;"></span>
                        </div>
                      </div>
                      <div class="res-qa-item-r">
                        <p class="quest-p">
                          <span class="font-weight" v-if="trim(ans.rername) !== ''">【{{ ans.rertitle }}: {{ ans.rername }}】</span>
                          <span class="ques-lt" v-if="!ans.showans"> {{{ ans.shortans?ans.shortans:ans.ans | maxlen 100 }}}</span>
                          <span class="ques-lt" v-show="ans.showans"> {{{ ans.ans }}}</span>
                          <span class="qust-more blue" v-if="!ans.showans && ans.ans.length>100" @click="ans.showans=true"> 展开更多<span class="triangle-bottom"></span> </span>
                          <span class="qust-stop red" v-if="ans.showans" @click="ans.showans=false"> 收起<span class="triangle-head"></span></span>
                        </p>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </div>
          <!--公司-->
          <div v-if="tab1 === 2" class="search-company-box">
            <div class="search-company-main" v-for="company in companyitems" track-by="$index">
              <h3 class="head" @click.stop="goCompanyDetail(company), setCnzz('[Mobile]-深度搜索', '查看公司详情', '')">{{company.shortName}}({{company.companyCode}})</h3>
              <div class="search-company-list">
                <p><span  class="title">法人</span> <span class="mar">{{company.legalRepresentative}}</span></p>
                <p><span  class="title">成立日期</span>  <span class="mar">{{company.founddate}}</span>
                  <span class="title">所属地域</span> <span class="mar">{{company.area}}</span></p>
              </div>
              <div class="search-company-list last-child">
                <p>
                  <span  class="title">行业</span>
                  <span class="mar">{{company.industry}}</span>
                </p>
                <p>
                  <span  class="title">营业收入</span>
                  <span class="mar" v-if="company.businessincome">{{company.businessincome | formatNumber}}</span>
                  <span class="mar" v-if="!company.businessincome" style="margin: 0 .5rem">-</span>
                  <span>(元)</span>
                </p>
                <p>
                  <span class="title">净利润</span>
                  <span class="mar" v-if="company.retainedprofit">{{company.retainedprofit | formatNumber}}</span>
                  <span class="mar" v-if="!company.retainedprofit" style="margin: 0 .5rem">-</span>
                  <span>(元)</span>
                </p>
              </div>
            </div>
          </div>
          <!--加载动画-->
          <template v-if="tab1 === 1">
            <div class="more" v-show="!loading && bottomPage < totalPage && total !== 0" style="margin-top: -8px;">
              <i class="pull_icon loading"></i>
              <span style="font-size: 15px;">加载中...</span>
            </div>
          </template>
          <template v-if="tab1 === 2">
            <div class="more" v-show="!loading && cpage < totalPage && ctotal1 !== 0" style="margin-top: -8px;">
              <i class="pull_icon loading"></i>
              <span style="font-size: 15px;">加载中...</span>
            </div>
          </template>
        </div>
        <!-- /. 搜索结果 -->
      </div>
    </div>

    <!--公司详情-->
    <div class="wrapper" v-show="tab1 == 2 && showCompanyDetailWrap">
      <div class="company-details-title">
        <span class="cancle-btn" @click.stop="hideCompanyDetail(), setCnzz('[Mobile]-深度搜索', '收起公司详情', '')"></span>
        <span class="menu-options blue" style="font-size: 16px">{{currentCompanyDetail.shortName}}({{currentCompanyDetail.companyCode}})</span>
      </div>
      <div class="company-details-head">
        <div class="search-company-list">
          <p><span class="title">法人</span> <span class="mar">{{currentCompanyDetail.legalRepresentative}}</span></p>
          <p><span class="title">成立日期</span>  <span class="mar">{{currentCompanyDetail.founddate}}</span>
            <span class="title">所属地域</span> <span class="mar">{{currentCompanyDetail.area}}</span></p>
        </div>
        <div class="search-company-list last-child">
          <p><span class="title">行业</span> <span class="mar">{{currentCompanyDetail.industry}}</span></p>
          <p>
            <span class="title">营业收入</span>
            <span class="mar" v-if="currentCompanyDetail.businessincome">{{currentCompanyDetail.businessincome | formatNumber}}</span>
            <span class="mar" v-if="!currentCompanyDetail.businessincome" style="margin: 0 .5rem;">-</span>
            <span>(元)</span>
          </p>
          <p>
            <span class="title">净利润</span>
            <span class="mar" v-if="currentCompanyDetail.retainedprofit">{{currentCompanyDetail.retainedprofit | formatNumber}}</span>
            <span class="mar" v-if="!currentCompanyDetail.retainedprofit" style="margin: 0 .5rem;">-</span>
            <span>(元)</span>
          </p>
        </div>
      </div>
      <div class="company-details-box">
        <ul class="one-row-box">
          <li>
            <p class="date"> 公司名 </p>
            <p class="time"> {{currentCompanyDetail.companyName}} </p>
          </li>
          <li>
            <p class="date"> 统一社会信用代码 </p>
            <p class="time"> {{currentCompanyDetail.regcode}} </p>
          </li>
          <li>
            <p class="date">注册资本</p>
            <p class="time"> {{currentCompanyDetail.regmoney | formatNumber}}（万元） </p>
          </li>
          <li>
            <p class="date"> 曾用名 </p>
            <p class="time" v-if="currentCompanyDetail.companyNames && currentCompanyDetail.companyNames.length == 0"> 暂无曾用名 </p>
            <p class="time">
              <ul style="margin: 0rem 0.25rem;font-size: 0.7rem;color: rgba(0,0,0,0.54);">
                <li v-for="cname in currentCompanyDetail.companyNames">{{cname.name}}</li>
              </ul>
            </p>
          </li>
          <li>
            <p class="date"> 注册地址 </p>
            <p class="time"> {{currentCompanyDetail.address}} </p>
          </li>
          <li>
            <p class="date"> 企业类型 </p>
            <p class="time"> {{currentCompanyDetail.companytyp}} </p>
          </li>
          <li>
            <p class="date"> 经营范围 </p>
            <p class="time"> {{currentCompanyDetail.businessscope}} </p>
          </li>
        </ul>
      </div>
    </div>
    <!--保存标签-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-if="showModalTag">
      <div class="comment-content-tag">
         <div class="login-close" @click="showModalTag = false">
           <a class="delete-icon"></a>
        </div>
          <div class="comment-reply">
           <input class="input-search-c"  type="text" placeholder="输入标签名称" v-model="tagname">
           <a class="btn-Publish" @click="saveTag()">确定</a>
          </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-if="showModalTag"></div>
    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind && !loading">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage">立即绑定</a>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
    <!-- / 微信绑定弹框-->

    <!--智能索引-公司详情-->
    <div class="wrapper" v-show="smartEngine.open">
      <div class="company-details-title">
        <span class="cancle-btn" @click.stop="smartEngine.open = false, setCnzz('[Mobile]信披搜索', '收起公司详情', '')"></span>
        <span class="menu-options blue" style="font-size: 16px">{{smartEngine.companyInfo.shortname}}({{smartEngine.companyInfo.code}})</span>
      </div>
      <div class="company-details-head">
        <div class="search-company-list">
          <p><span class="title">法人</span> <span class="mar">{{smartEngine.companyInfo.legalRepresentative}}</span></p>
          <p><span class="title">成立日期</span>  <span class="mar">{{smartEngine.companyInfo.founddate}}</span>
            <span class="title">所属地域</span> <span class="mar">{{smartEngine.companyInfo.area}}</span></p>
        </div>
        <div class="search-company-list last-child">
          <p><span class="title">行业</span> <span class="mar">{{smartEngine.companyInfo.industry}}</span></p>
        </div>
      </div>
      <div class="company-details-box">
        <ul class="one-row-box">
          <li>
            <p class="date"> 公司名称 </p>
            <p class="time"> {{smartEngine.companyInfo.name}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.name_en">
            <p class="date"> 英文名称 </p>
            <p class="time"> {{smartEngine.companyInfo.name_en}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.regcode">
            <p class="date"> 统一社会信用代码 </p>
            <p class="time"> {{smartEngine.companyInfo.regcode}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.regmoney">
            <p class="date">注册资本</p>
            <p class="time"> {{smartEngine.companyInfo.regmoney | formatNumber}}（万元） </p>
          </li>
          <li v-if="smartEngine.companyInfo.secretaries">
            <p class="date"> 董 秘 </p>
            <p class="time"> {{smartEngine.companyInfo.secretaries}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.address">
            <p class="date"> 注册地址 </p>
            <p class="time"> {{smartEngine.companyInfo.address}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.website">
            <p class="date"> 公司网址 </p>
            <p class="time"> {{smartEngine.companyInfo.website}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.phone">
            <p class="date"> 电 话 </p>
            <p class="time"> {{smartEngine.companyInfo.phone}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.fax">
            <p class="date"> 传 真 </p>
            <p class="time"> {{smartEngine.companyInfo.fax}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.postcode">
            <p class="date"> 邮 编 </p>
            <p class="time"> {{smartEngine.companyInfo.postcode}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.companytyp">
            <p class="date"> 企业类型 </p>
            <p class="time"> {{smartEngine.companyInfo.companytyp}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.businessscope">
            <p class="date"> 经营范围 </p>
            <p class="time"> {{smartEngine.companyInfo.businessscope}} </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-comment" style="bottom:0px;" v-if="!showCompanyDetailWrap">
  <span class="footer-text"><a href="javascript:;" @click="commentinput = true, content= '',pid = 0"><i class="comment-icon"></i>评论一下</a></span>
  <span class="footer-zan" v-show="!showComments"> <a href="javascript:;" @click="showComments = true, loadcomment()"><span class="qinp"><i></i>{{cpwtotal}}</span></a>
  </span>
  <span class="footer-zan" v-show="showComments"> <a href="javascript:;" @click="showComments = false"><span class="text"><i></i>返回搜索</span></a>
  </span>
</div>

  <!--评论弹窗-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-show="commentinput" @click.self="commentinput = false">
    <div class="comment-content-tag">
       <div class="login-close">
         <a class="delete-icon" href="javascript:;" @click="commentinput = false"></a>
      </div>
        <div class="comment-reply">
         <textarea cols="" rows="2" class="input-a" placeholder="输入发表内容" v-model="content"></textarea>
         <span class="anonymous" @click="anonym == 1 ? anonym = 0:anonym = 1">
             <label class="el-checkbox mar">
              <span class="el-checkbox-input" :class="{'is-checked':anonym === 1}"><span class="el-checkbox-inner"></span>
              </span>
              <span class="el-checkbox-label">匿名评论</span>
              </label>
           </span>
         <a class="btn-Publish" href="javascript:;" @click="commentinput = false,addComment(2, sid)">发表</a>
        </div>
    </div>
   </div>
  <div v-if="commentinput" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all" id="ui-datepicker-div"></div>
  <div v-if="commentinput" class="modal-backdrop fade in"></div>

  <bigimg :bigimgobj="bigImgObj"></bigimg>
 </div>
</template>

<script>
  import {apiUrl, dateFormat, alert, isEmptyObj, confirm} from '../../helper'
  import myDatepicker from '../../helper/datepicker.vue'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import commentMix from '../notice/commentMix'
  import searchMix from '../../common/SearchMix'
  import comSearchMix from '../../common/comSearchMix.js'
  import wxshareMix from '../../common/wxshareMix'
  import searchResMix from '../../common/searchResMix'
  import BigImg from '../BigImg'

  export default {
    name: 'AdvSearchView',
    mixins: [userMix, wxshareMix, searchMix, commentMix, comSearchMix, searchResMix],
    components: {
      'bigimg': BigImg,
      'date-picker': myDatepicker
    },
    data () {
      return {
        bigImgObj: {'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': ''},
        gglxList: {},
        ggbqList: {},
        advdownloading: false,
        tab1: 1,    // 1公告 2.公司 3.使用范例
        tab2: 1,    // 1搜索结果 2.分析
        tab3: 1,    // 我的标签 1公告 2公司  3人员  1范例 2我的标签
        searched: false,
        companysearched: false,
        sd: '',
        cpage: 1,     // 公司-当期页
        ctotal: 0,    // 公司-total
        ctotal1: 0,   // 公司-length
        cperPage: 10, // 公司-每页显示条目
        curcond: null,
        stype: 1,
        condition: [],
        querycond: [],
        showCondition: false,
        showCustom: false,
        customCols: [{'name': '证劵简称', 'col': 'shortName', 'show': true}, {'name': '证劵代码', 'col': 'companyCode', 'show': true}, {'name': '法人', 'col': 'legalRepresentative', 'show': true}, {'name': '所属地域', 'col': 'area', 'show': true}, {'name': '行业', 'col': 'industry', 'show': true}, {'name': '成立日期', 'col': 'founddate', 'show': true}, {'name': '注册资本(万元)', 'col': 'regmoney', 'show': true, 'format': 'money'}, {'name': '营业总收入(元)', 'col': 'businessincometotal', 'show': true, 'format': 'money'}, {'name': '营业收入(元)', 'col': 'businessincome', 'show': true, 'format': 'money'}, {'name': '净利润(元)', 'col': 'retainedprofit', 'show': true, 'format': 'money'}, {'name': '企业类型', 'col': 'companytyp', 'show': false}, {'name': '统一社会信用代码/注册号', 'col': 'regcode', 'show': false}, {'name': '注册地址', 'col': 'address', 'show': false}],
        items: [],
        companylist: [],    // 完整公司列表
        companyitems: [],   // 已展示出来的公司列表
        datepicker: {
          option: {
            type: 'day',
            week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
            format: 'YYYY-MM-DD',
            placeholder: '',
            inputStyle: {
              'display': 'inline-block',
              'width': '110px',
              'padding': '4px',
              'line-height': '22px',
              'font-size': '16px',
              'border': '1px solid rgb(198, 216, 232)',
              'box-shadow': '0 0 0 0 rgba(0, 0, 0, 0.2)',
              'border-radius': '4px',
              'color': '#5F5F5F'
            },
            color: {
              header: '#00736a',
              headerText: '#ffffff'
            },
            buttons: {
              clear: '清空',
              today: '今天',
              ok: '确定',
              cancel: '取消'
            },
            overlayOpacity: 0.5, // 0.5 as default
            dismissible: true    // as true as default
          }
        },
        meta: [],
        crumbs: [],
        lvl1: [],
        lvl2: [],
        lvl3: [],
        metaMap: {},    // 元数据图
        uniqMap: {},
        showModal: false,
        tagname: '',
        showTag: false,
        tags: [],
        tags1: [],
        tags2: [],
        tags3: [],
        samples: [
          {'typ': 1, 'condition': [{'name': '搜索范围', 'code': 'ssfw', 'type': 'Select', 'op': 1, 'child': [{'name': '章节', 'code': 'zjbt', 'type': 'Select', 'op': 1, 'child': [{'name': '章节标题', 'code': 'jzjbt', 'type': 'String', 'op': 1, 'value': '主营业务', 'child': []}, {'name': '章节正文', 'code': 'zjzw', 'type': 'String', 'op': 1, 'value': '大数据', 'child': []}]}]}], 'stype': 2, 'perPage': 10, 'page': 1, 'sort': 1},
          {'typ': 2, 'condition': [{'name': '搜索范围', 'code': 'ssfw', 'type': 'Select', 'op': 1, 'child': [{'name': '章节', 'code': 'zjbt', 'type': 'Select', 'op': 1, 'child': [{'name': '章节标题', 'code': 'jzjbt', 'type': 'String', 'op': 1, 'value': '主营业务', 'child': []}, {'name': '章节正文', 'code': 'zjzw', 'type': 'String', 'op': 1, 'value': '大数据', 'child': []}]}]}, {'name': '公司', 'code': 'company', 'type': 'Select', 'op': 1, 'child': [{'name': '财务数据', 'code': 'cwsj', 'type': 'Select', 'op': 1, 'child': [{'name': '财报指标', 'code': 'cwzb', 'type': 'Select', 'op': 1, 'child': [{'name': '营业总收入', 'code': 'yyzsr', 'type': 'Finance', 'op': 1, 'range': 2, 'value': '50,000,000', 'value1': '', 'year': '2016', 'quarter': '年报', 'child': []}, {'name': '净利润', 'code': 'jlr', 'type': 'Finance', 'op': 1, 'range': 2, 'value': '5,000,000', 'value1': '', 'year': '2016', 'quarter': '年报', 'child': []}]}]}]}], 'stype': 2, 'perPage': 10, 'page': 1, 'sort': 1}
        ],
        exportfilepath: '',
        searchCondition: [],
        newSearchCondition: [],
        // ---------------------------------------------------------
        loading: 0,
        onlyTitle: 0,  // 只显示标题
        page: 1,       // 分页
        total: 0,      // 数据总数
        perPage: 10,    // 每页显示数目
        totalPage: 0,  // 总页数
        detailLists: [],  // 数据
        topPage: 0,       // 处于最顶部分页页码
        bottomPage: 0,    // 处于最底部分页页码
        newItems: [],     // 每次分页加载所获得的数据
        sort: 1,          // 1：按相关性排序，2：按时间排序
        company: [],      // 公司
        showdownBtn: true,
        related_company: [],   // 关联公司
        related_name: [],      // 相关人名
        aggTypes: [],   // 公告类型
        aggPlates: [],  // 板块类型
        aggLabels: [],  // 公告标签
        checkedAll: false,  // 选择全部
        checkedCount: 0,    // 选中数目
        showSort: false,    // 按日期顺序显示
        showDropdownMenu: '',   // 下拉框
        showSearchPage: false,    // 搜索结果
        showTongjiPage: false,    // 统计
        showResultPage: true,     // 搜索结果
        showStatAnalyze: true,    // 分析
        showStatFilter: false,     // 筛选
        uidUrl: '',    // 用户id
        share: '',  // 分享位置, 'weixin'
        plat: '',   // 平台, 'web'
        sid: '',
        diysharedesc: '',   // 自定义分享描述
        currentCompanyDetail: {},        // 当前展示的公司详情对象
        showCompanyDetailWrap: false,    // 公司详情页
        scrollTopPos: null,               // 打开公司详情那一时刻，滚动条位置
        params: {},
        // 智能引擎
        dataMap: {'年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31'},
        upanddown: 0,
        Amplitude: 0,
        timetyp: 1,
        smartComInfo: {},
        finance: [],
        yearfinance: [],
        ssfw: {},          // 搜索范围
        gs: {}             // 公司
      }
    },
    ready () {
      this.$nextTick(function () {
        // 设置页面最低高度等于屏幕可是区域高度
        let innerHeight = window.innerHeight + 'px'
        $('.wrapper').css({'min-height': innerHeight})
      })
    },
    route: {
      data ({ to }) {
        console.log(to)
        console.log('进入Advearch')
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query)
          }
        }
        if (this.currentuser) {
          $.ajax({
            url: apiUrl('/V1.0.0/notice/advmeta'),
            method: 'post',
            dataType: 'json'
          }).done((response) => {
            if (response.status === 0) {
              this.meta = response.result.condition
              this.getMetaMap(this.meta)
              this.initCond()
              this.parseUrlQuery(to.query)
            }
          }).fail((response) => {
            alert('请求失败')
          })
          // 智能引擎
          this.upanddown = 0
          this.Amplitude = 0
          this.switchPage(2)
          let urlQuery = to.query
          this.params.uidUrl = urlQuery.uid
          this.params.share = urlQuery.share
          this.params.plat = urlQuery.plat
          this.params.ts = urlQuery.ts
          this.params.desc = urlQuery.desc
          this.params.sid = urlQuery.sid
          this.params.ruid = urlQuery.ruid
          this.uidUrl = urlQuery.uid
          this.share = urlQuery.share
          this.plat = urlQuery.plat
          this.sid = urlQuery.sid
          this.page = urlQuery._page
          this.diysharedesc = urlQuery.desc
          this.gettags()
          this.commentList = []
          this.commentinput = false
          this.showComments = false
          this.getCommentcount(2,this.sid)
          // ==================================================================
          jQuery(window).unbind()
          $(window).unbind()
          let that = this
          $(window).scroll(function (e) {
            if (($(window).scrollTop() + $(window).height()) >= $(document).height() && that.showComments) {
              let page = that.cpwpage + 1
              // console.log(that.cpwpage)
              if (page <= Math.ceil(that.cpwtotal / 10)) {
                that.getCommentList(page, 2, that.sid)
              }
              // that.getCommentList(that.md5)
            }
            let scrollTop = $(this).scrollTop()       // 滚动条距页顶的距离
            let scrollHeight = $(document).height()   // 浏览器时下窗口文档的高度
            let windowHeight = $(this).height()
            if (that.tab1 === 1) {
              // 若滚动到顶部
              if (scrollTop == 0) {
                console.log('current topPage: ' + that.topPage)
                let top_page = parseInt(that.topPage) - 1
                console.log('loading page: ' + top_page)
                console.log('totalPage: ' + that.totalPage)
                if (that.topPage > 1) {  // 最顶部分页页码>1
                  that.page = that.topPage
                  that.topPage--
                  that.paging(that.topPage)
                  let newDetailLists = that.newItems.concat(that.detailLists)
                  that.detailLists = newDetailLists
                  that.$nextTick(function () {
                    let resultList10 = $('.search-result-list')[9]
                    let offsetTop = resultList10.offsetTop
                    let offsetHeight = resultList10.offsetHeight
                    let newOffsetTop = offsetTop + offsetHeight
                    $(window).scrollTop(newOffsetTop)
                  })
                }
              }
              // 滚动到底部
              if (scrollTop + windowHeight >= scrollHeight) {
                console.log('current bottomPage: ' + that.bottomPage)
                console.log('loading page: ' + that.bottomPage+1)
                console.log('totalPage: ' + that.totalPage)
                if (that.bottomPage < that.totalPage) {  // 最底部分页页码<总页数
                  that.page = that.bottomPage
                  that.bottomPage++
                  that.paging(that.bottomPage)
                  let newDetailLists = that.detailLists.concat(that.newItems)
                  that.detailLists = newDetailLists
                }
              }
            }
            if (that.tab1 === 2) {   // 公司
              if (scrollTop == 0) {
                that.topPage = 1;
              }
              // 滚动到底部
              if (scrollTop + windowHeight >= scrollHeight) {
                console.log('cpage: ' + that.cpage)
                console.log('loading next page: ' + that.cpage+1)
                console.log('totalPage: ' + that.totalPage)
                if (that.cpage < that.totalPage) {  // 最底部分页页码<总页数
                  let cpage = that.cpage + 1
                  that.gocompany(cpage)
                }
                if (that.cpage === that.totalPage) {
                  $(this).unbind(e)
                }
              }
            }
          })
          this.$nextTick(function () {
            // 微信分享
            let wxsharedesc = this.getShareDesc()
            let wxsharetitle = this.getShareTitle()
            this.shareResult(wxsharetitle, wxsharedesc)

            if (this.params.desc && this.params.desc !='') {
              document.title = this.params.desc;
            }
          })
        }
      }
    },
    methods: {
      // 查看大图
      setBigImgObj: function (item, article) {
        this.bigImgObj.imghead = item.imghead
        this.bigImgObj.imgfoot = item.imgfoot
        this.bigImgObj.imgurl = item.imgurl
        this.bigImgObj.imgid = item.imgid

        this.bigImgObj.companycode = article.companyCode;
        this.bigImgObj.companyname = article.companyName;
        this.bigImgObj.md5 = article.id;
        this.bigImgObj.publishdate = article.publishDate;
        // this.bigImgObj.shortname = article.shortname;
        this.bigImgObj.stype = this.stype;
        this.bigImgObj.title = article.title;

        this.bigImgObj.show = true
      },
      loadcomment: function () {
        if (this.commentList.length == 0) {
          this.getCommentList(1, 2, this.sid)
        }
      },
      backToHistory () {
        window.history.back()
      },
      /**
       * 自定义下拉框
       * @param param - 字符串，用于确定打开的是哪一个下拉框
       */
      slideToggle (param) {
        if (this.showDropdownMenu === '') {
          this.showDropdownMenu = param
          // 点击下拉容器内，隐藏下拉
          $('.slide-menu').click(function () {
            this.showDropdownMenu = ''
            $(this).css({'display': 'none'})
          })
        } else {
          this.showDropdownMenu = ''
        }
      },
      /**
       * 搜索条件-手风琴切换效果
       */
      slideDropdownMenu (event) {
        $('.Screen-criteria-box').slideToggle('normal')  // slow, normal, fast
        let el = event.currentTarget
        let iconDom = el.lastElementChild
        let iconClass = iconDom.getAttribute('class'),
          class1 = iconClass.split(' ')[0],
          class2 = iconClass.split(' ')[1]
        if (class2 === 'close') {
          let _class = class1 + ' ' + 'open'
          iconDom.setAttribute('class', _class)
        }
        if (class2 === 'open') {
          let _class = class1 + ' ' + 'close'
          iconDom.setAttribute('class', _class)
        }
      },
      checkLogin (item) {
        if (this.currentRegtyp === 4) {
          this.tipGoBind = true
          return
        }
        let url = ''
        if (item.viewtype === 2) {
          url = item.sourceurl
          window.location.href = url
        } else {
          url = window.location.origin + this.viewUrl(item, this.params)
          window.location.href = url
        }
      },
      checkLoginQa: function (item) {
        if (this.currentRegtyp === 4) {
          this.tipGoBind = true
          return
        }
        let url = window.location.origin + this.qaViewUrl(item, this.params)
        if (item.viewtype === 2) {
          window.location.href = item.sourceurl
        } else {
          window.location.href = url
        }
      },
      hideKeywordDropdown () {
        let el = $('.date-menu')
        if (el.hasClass('open')) {
          el.removeClass('open').addClass('close')
        }
      },
      /**
       * 添加筛选条件
       * @param type： 类型
       * @param obj： 条件
       */
      addConditionNew: function (type, obj) {
//        if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
//          alert('请输入关键词或股票代码')
//          return
//        }
        if (!this.conditions[type][obj.code]) {
          let tmp = {}
          tmp[obj.code] = obj.name
          this.conditions[type] = Object.assign({}, this.conditions[type], tmp)
          if (this.searched) {
            this.go()
          }
        } else {
          let conditions = this.conditions
          delete conditions[type][obj.code]
          this.conditions = Object.assign({}, conditions)
          if (this.searched) {
            this.go()
          }
        }
        this.showMylabels = 2
        this.addToShow()
      },
      /**
       * 自定义分页操作
       */
      paging (page) {
        let query = this.genQuery()
        query.page = page
        query.perPage = this.perPage
        query.uid = parseInt(this.uidUrl)
        query.share = this.share
        query.plat = this.plat
        query.sid = this.sid
        query.ruid = this.params.ruid
        let reqUrl = ''
        if (this.stype === 2) {
          reqUrl = apiUrl('/V1.0.0/notice/advsearchn3b')
        } else {
          reqUrl = apiUrl('/V1.0.0/notice/advsearch')
        }
        $.ajax({
          url: reqUrl,
          method: 'post',
          dataType: 'json',
          async: false,  // 同步
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          this.analyze()  // 分析
          if (response.status === 0) {
            let items = response.lists
            for (let item of items) {
              item.checked = false
              if (item.child) {
                for (let child of item.child) {
                  child.showque = false
                  if (child.answers) {
                    for (let ans of child.answers) {
                      ans.showans = false
                    }
                  }
                }
              }
            }
            this.newItems = items
          } else if (response.status === 502) {
            alert('很抱歉，请求超时请重新搜索')
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      // 搜索
      search () {
        this.getList()
        console.log("1594")
        let query = this.genQuery()
        console.log(query);
        if (query.ai === 1) {
          if (this.checkAction('search/ai')) {
            query.ai = 1
          } else {
            query.ai = 0
          }
        }
        query.perPage = this.perPage
        query.uid = parseInt(this.uidUrl)
        query.share = this.share
        query.plat = this.plat
        query.sid = this.sid
        query.ruid = this.params.ruid
        // console.log(query);
        let page = query.page
        this.topPage = page
        this.bottomPage = page
        this.page = page
        // ----------------------------------
        let reqUrl = ''
        if (this.stype === 2) {
          reqUrl = apiUrl('/V1.0.0/notice/advsearchn3b')
        } else {
          reqUrl = apiUrl('/V1.0.0/notice/advsearch')
        }
        this.loading = true
        $.ajax({
          url: reqUrl,
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          this.searched = true
          this.finance = []
          this.yearfinance = []
          if (this.tab1 === 2) {
            this.companysearched = true
          }
          if (response.status === 0) {
            this.sd = response.sd
            this.exportfilepath = response.url
            if (this.tab1 === 1) {    // 公告
              this.initAnaly()
              let items = response.lists
              for (let item of items) {
                item.checked = false
                if (item.child) {
                  for (let child of item.child) {
                    child.showque = false
                    if (child.answers) {
                      for (let ans of child.answers) {
                        ans.showans = false
                      }
                    }
                  }
                }
              }
              this.items = items
              this.detailLists = items
              this.total = response.total   // 数据总数
              this.totalPage = Math.ceil(this.total / 5)
              this.analyze()
              // console.log('this.tab1===1')
            }
            if (this.tab1 === 2) {    // 公司
              let items = response.lists
              this.companylist = items
              this.ctotal = response.total
              this.ctotal1 = items.length
              this.gocompany(1)
            }
            // 智能引擎
            this.smartComInfo = response.company || {}
            if (this.smartComInfo.finance && this.smartComInfo.finance.length > 0) {
              let a = [' ']
              for (let k in this.smartComInfo.finance[0]) {
                if (k !== 'plate' && k !== 'reportdate' && k !== 'reportdatestr') {
                  a.push(k)
                }
              }
              this.finance.push(a)
              this.yearfinance.push(a)
              for (let item of this.smartComInfo.finance) {
                let arr = []
                if (item.plate === 'A') {
                  for (let i in item) {
                    if (i !== 'plate' && i !== 'reportdatestr') {
                      arr.push(item[i])
                    }
                  }
                  this.finance.push(arr)
                } else {
                  for (let i in item) {
                    if (i !== 'plate' && i !== 'reportdate') {
                      arr.push(item[i])
                    }
                  }
                  this.finance.push(arr)
                }
              }
              for (let i of this.finance) {
                if (this.smartComInfo.type === 'A') {
                  if (i[0] && i[0].indexOf('-12-') > 0) {
                    this.yearfinance.push(i)
                  }
                } else {
                  if (i[0] && i[0].indexOf('年报') > 0) {
                    this.yearfinance.push(i)
                  }
                }
              }
              // console.log('finance ---------------------------------------');
              // console.log(this.finance)
              // console.log(this.yearfinance)
              // console.log('-----------------------------------------------');
              for (let i of this.finance) {
                if (i[0].indexOf('年') >= 0) {
                  i[0] = i[0].substr(0, 4) + this.dataMap[i[0].substr(4)]
                }
              }
              for (let i of this.yearfinance) {
                if (i[0].indexOf('年') >= 0) {
                  i[0] = i[0].substr(0, 4) + this.dataMap[i[0].substr(4)]
                }
              }
              this.finance.sort(function (a, b) {return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))})
              this.yearfinance.sort(function (a, b) {return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))})
            } else {
              this.finance = []
              this.yearfinance = []
            }
            this.prices = this.smartComInfo.price || {}
            if (this.prices.trade && this.prices.settlement) {
              this.upanddown = (this.prices.trade - this.prices.settlement).toFixed(2)
              if (this.upanddown > 0 || this.upanddown == 0) {
                this.upanddown = '+' + this.upanddown
              }
              this.Amplitude = ((this.prices.trade - this.prices.settlement)/ this.prices.settlement * 100).toFixed(2)
              if (this.Amplitude > 0) {
                this.Amplitude = '+' + this.Amplitude
              }
            }
            this.searched = this.stype
            // 如果分享过来时是第一页
            if (this.page !== 1) {
              this.$nextTick(function () {
                $(window).scrollTop(23)
              })
            }
          } else if (response.status === 502) {
            alert('很抱歉，请求超时请重新搜索')
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      selSort (val) {
        this.sort = val   // 1：按相关性排序，2：按时间排序
        this.showSort = false
        if (this.searched) {
          this.go()
        }
      },
      /*
       * 微信分享
       * */
      shareResult (fulltitle, desc) {
        let title = fulltitle
        // 微信分享——权限验证
        let query = {}
        query.url = window.location.href.split('#')[0]
        $.ajax({
          url: apiUrl('/V1.0.0/user/getwxsign'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          if (response.status === 0) {
            let data = response.data
            // 通过config接口注入权限验证配置
            wx.config({
              debug: false,
              appId: this.$config.weixin.appid,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                'checkJsApi',
                'onMenuShareAppMessage',
                'onMenuShareTimeline'
              ]
            })
            let href = window.location.href
            href = this.changeUrlArg(href, 'uid', this.uid)
            href = this.changeUrlArg(href, 'ruid', this.params.uidUrl)
            let shareLink = href
            let shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg'
            let that = this
            // 通过ready接口处理config成功验证
            wx.ready(function () {
              wx.checkJsApi({   // 需要检测的JS接口列表
                jsApiList: [
                  'onMenuShareAppMessage',
                  'onMenuShareTimeline'
                ],
                success: function (res) {
                  // 以键值对的形式返回，可用的api值true，不可用为false
                  // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                  console.log(JSON.stringify(res))
                }
              })
              // 注册获取“发送给朋友”状态事件
              wx.onMenuShareAppMessage({
                title: title,
                desc: desc,
                link: shareLink,
                imgUrl: shareImgLink,
                trigger: function (res) {   // 监听Menu中的按钮点击时触发的方法，该方法仅支持Menu中的相关接口
                  // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                  console.log('用户点击发送给朋友')
                },
                success: function (res) {
                  console.log('分享给朋友——成功！')
                  that.shareStatus(that.params.sid, 1)
                },
                cancel: function (res) {
                  console.log('分享给朋友——取消！')
                },
                fail: function (res) {
                  console.log(JSON.stringify(res))
                  that.shareStatus(that.params.sid, 3)
                }
              })
              // 注册获取“分享到朋友圈”状态事件
              wx.onMenuShareTimeline({
                title: title,
                link: shareLink,
                imgUrl: shareImgLink,
                trigger: function (res) {
                  console.log('用户点击发送给朋友圈')
                },
                success: function (res) {
                  console.log('分享到朋友圈——成功！')
                  that.shareStatus(that.params.sid, 1)
                },
                cancel: function (res) {
                  console.log('分享到朋友圈——取消！')
                },
                fail: function (res) {
                  console.log(JSON.stringify(res))
                  that.shareStatus(that.params.sid, 3)
                }
              })
            })
            // 通过error接口处理失败config验证
            wx.error(function(res) {
              console.log(JSON.stringify(res))
            })
          }
        }).fail((response) => {
          alert('请求失败')
        })
      },
      getShareTitle () {
        let desc = ''
        if (this.diysharedesc === '') {
          desc = '深度搜索是一种强力搜索模式，它允许用户创建多维度的复合搜索条件，从而支持强大的信息定位能力，实现更为精准的搜索效果。通过深度搜索，用户可以构建起接近自然语言的复杂查询，并且在瞬间获得精准的搜索结果。'
        } else {
          desc = this.diysharedesc
        }
        return desc
      },
      getShareDesc () {
        let sharetitle = '你的朋友' + this.shareUsername + '通过IBDATA给你分享了一份他的独家数据！'
        return sharetitle
      },
      // 深度搜索——绑定微信
      goBindPage () {
        let nowUrl = window.location.href + '&desc=' + this.diysharedesc
        this.getShortLink(nowUrl)
        let uri = encodeURIComponent(this.goBindPageShortLink)
        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri
      },
      // 打开公司详情
      goCompanyDetail (item) {
        if (this.currentRegtyp === 4) {   // 未绑定微信，提示去绑定
          this.tipGoBind = true
          return
        }
        this.scrollTopPos = $(window).scrollTop()   // 当前滚动条位置
        console.log(this.scrollTopPos)
        this.currentCompanyDetail = item
        this.showCompanyDetailWrap = true
        $(window).scrollTop(0)
      },
      // 关闭公司详情
      hideCompanyDetail () {
        this.showCompanyDetailWrap = false
        this.currentCompanyDetail = {}
        let pos = this.scrollTopPos
        let timer = setTimeout(function () {
          $(window).scrollTop(pos)
//          console.log(pos)
//          pos = pos.toString() + 'px'
//          $('html, body').animate({scrollTop: pos}, 100)
        }, 100)
      },
      /**
       * 搜索公司
       * */
      gocompany (page) {
        this.cpage = page || 1
        this.cpage = this.cpage > this.totalPage ? this.totalPage : this.cpage
        let begin = this.cperPage * (this.cpage - 1)
        let newitems = this.companyitems.concat(this.companylist.slice(begin, begin + this.cperPage))
        this.companyitems = newitems
        console.log(this.companyitems)
      },
      // ======================================================================================
      onlyTitleGet: function () {
        this.onlyTitle = !this.onlyTitle
      },
      dropdown: function (e) {
        let tar = $('.tag-button')
        if (!tar.is(e.target) && tar.has(e.target).length === 0) {
          this.tab3 = 0
        }
      },
      downOne (item, i) {
        $('.advDow_' + i).css('display', 'none')
        $('#advDow_' + i).css('display', 'block')
        let a = this.downloadUrl(item)
        window.location.href = a
        setTimeout(function () {
          $('.advDow_' + i).css('display', 'block')
          $('#advDow_' + i).css('display', 'none')
        }, 1000)
      },
      initAnaly () {
        this.company = []
        this.related_company = []
        this.related_name = []
        this.aggTypes = []
        this.aggPlates = []
        this.aggLabels = []
      },
      /**
       * 获取元数据图谱
       * @param {Object} conditions - 元数据对象
       */
      getMetaMap (conditions) {
        for (let d of conditions) {
          this.metaMap[d.code] = d
          if (d.hasOwnProperty('child')) {
            if (d.child.length > 0) {
              this.getMetaMap(d.child)
            }
          }
        }
      },
      /*
      *
      * */
      getCrumbs (conditions, parent) {
        for (let d of conditions) {
          d.parent = parent || null
          let code = d.code
          if (code) {
            let metad = this.metaMap[code]
            if (metad.uniq === 1) {
              this.uniqMap[code] = 1
            }
          }
          if (d.parent) {
            let pcode = d.parent.code
            if (this.metaMap.hasOwnProperty(pcode)) {
              if (d.multi && pcode !== 'industry' && d.parent.parent) {
                let ppcode = d.parent.parent.code
                d.ref = this.metaMap[ppcode].child
              } else {
                d.ref = this.metaMap[pcode].child
              }
            }
          }
          if (d.hasOwnProperty('child')) {
            if (d.child.length > 0) {
              this.getCrumbs(d.child, d)
            }
          }
        }

        this.condition = conditions
      },
      common: function (condition) {
        this.ai = condition.ai
        this.searchCondition = condition.condition
        let searchCondition = condition.condition
        let ssfw = {    // 搜索范围
          all: [],
          ggbt: [],
          zw: [],
          zj: {
            zjzw: [],
            zjbt: []
          }
        }
        let gs = {    // 公司
          jbxx: {     // 基本信息
            gsmc: [],        // 公司名称
            region: [],      // 地区
            zczb: [],        // 注册资本
            gssz: [],        // 市值
            ssrq: [],        // 上市日期
            industry: [],    // 行业类型
            zyyw: [],        // 主营业务
            companycode: [], // 股票代码
            zcdz: []         // 注册地址
          },
          cwsj: {  // 财务数据
            cwzb: {
              yspj: [],   // 应收票据
              yszk: [],   // 应收账款
              ch: [],     // 存货
              ldzc: [],   // 流动资产
              zzc: [],    // 总资产
              ldfz: [],   // 流动负债
              fzze: [],   // 负债总额
              sszb: [],   // 实收资本
              gdqyhj: [], // 股东权益合计
              yyzsr: [],  // 营业总收入
              yysr: [],   // 营业收入
              yycb: [],   // 营业成本
              jlr: [],    // 净利润
              jbmgsy: [], // 基本每股收益
              xsmgsy: [], // 稀释每股收益
            },  // 财报指标
            gjbl: {
              zcfzl: [],        // 资产负债率
              ldbl: [],         // 流动比率
              sdbl: [],         // 速动比率
              mlv: [],          // 毛利率
              jlv: [],          // 净利率
              jzcsyl: [],       // 净资产收益率
              ckzzl: [],        // 存货周转率
              mgjzc: [],        // 每股净资产
              mgjyxjllje: []    // 每股经营活动产生的现金流量净额
            }   // 关键比率
          }
        }
        for (var sc of searchCondition) {
           if (sc.code === 'ssfw') {   // 搜索范围
            for (var c of sc.child) {
              if (c.code === 'all') {   // 全部
                ssfw.all.push(c)
              } else if (c.code === 'ggbt') {    // 公告标题
                ssfw.ggbt.push(c)
              } else if (c.code === 'zw') {    // 正文
                ssfw.zw.push(c)
              } else if (c.name === '章节') {   // 章节
                for (var i of c.child) {
                    if (i.code === 'zjzw') {    // 章节正文
                      ssfw.zj.zjzw.push(i)
                    }
                    if (i.code === 'jzjbt') {   // 章节标题
                      ssfw.zj.zjbt.push(i)
                    }
                }
              }
            }
          }
          if (sc.code === 'company') {  // 公司
            for (var c of sc.child) {
              if (c.code === 'jbxx') {  // 基本信息
                console.log('jbxx')
                for (var item of c.child) {
                  if (item.code === 'gsmc') {
                    gs.jbxx.gsmc.push(item)
                  } else if (item.code === 'region') {
                    gs.jbxx.region.push(item)
                  } else if (item.code === 'zczb') {
                    gs.jbxx.zczb.push(item)
                  } else if (item.code === 'gssz') {
                    gs.jbxx.gssz.push(item)
                  } else if (item.code === 'ssrq') {
                    gs.jbxx.ssrq.push(item)
                  } else if (item.code === 'industry') {
                    gs.jbxx.industry.push(item)
                  } else if (item.code === 'zyyw') {
                    gs.jbxx.zyyw.push(item)
                  } else if (item.code === 'companycode') {
                    gs.jbxx.companycode.push(item)
                  } else if (item.code === 'zcdz') {
                    gs.jbxx.zcdz.push(item)
                  }
                }
              }
              if (c.code === 'cwsj') {  // 财务数据
                console.log('财务数据')
                console.log(c)
                for (var item of c.child) {
                  if (item.code === 'cwzb') {  // 财务指标
                    console.log('cwzb');
                    for (var i of item.child) {
                      if (i.code === 'yspj') {            // 应收票据
                        gs.cwsj.cwzb.yspj.push(i)
                      } else if (i.code === 'yszk') {     // 应收账款
                        gs.cwsj.cwzb.yszk.push(i)
                      } else if (i.code === 'ch') {       // 存货
                        gs.cwsj.cwzb.ch.push(i)
                      } else if (i.code === 'ldzc') {     // 流动资产
                        gs.cwsj.cwzb.ldzc.push(i)
                      } else if (i.code === 'zzc') {      // 总资产
                        gs.cwsj.cwzb.zzc.push(i)
                      } else if (i.code === 'ldfz') {     // 流动负债
                        gs.cwsj.cwzb.ldfz.push(i)
                      } else if (i.code === 'fzze') {     // 负债总额
                        gs.cwsj.cwzb.fzze.push(i)
                      } else if (i.code === 'sszb') {     // 实收资本
                        gs.cwsj.cwzb.sszb.push(i)
                      } else if (i.code === 'gdqyhj') {   // 股东权益合计
                        gs.cwsj.cwzb.gdqyhj.push(i)
                      } else if (i.code === 'yyzsr') {    // 营业总收入
                        gs.cwsj.cwzb.yyzsr.push(i)
                      } else if (i.code === 'yysr') {     // 营业收入
                        gs.cwsj.cwzb.yysr.push(i)
                      } else if (i.code === 'yycb') {     // 营业成本
                        gs.cwsj.cwzb.yycb.push(i)
                      } else if (i.code === 'jlr') {      // 净利润
                        gs.cwsj.cwzb.jlr.push(i)
                      } else if (i.code === 'jbmgsy') {   // 基本每股收益
                        gs.cwsj.cwzb.jbmgsy.push(i)
                      } else if (i.code === 'xsmgsy') {   // 稀释每股收益
                        gs.cwsj.cwzb.xsmgsy.push(i)
                      }
                    }
                  }
                  if (item.code === 'gjbl') {  // 关键比率
                    console.log('gjbl');
                     for (var i of item.child) {
                      if (i.code === 'zcfzl') {           // 资产负债率
                        gs.cwsj.gjbl.zcfzl.push(i)
                      } else if (i.code === 'ldbl') {     // 流动比率
                        gs.cwsj.gjbl.ldbl.push(i)
                      } else if (i.code === 'sdbl') {     // 速动比率
                        gs.cwsj.gjbl.sdbl.push(i)
                      } else if (i.code === 'mlv') {      // 毛利率
                        gs.cwsj.gjbl.mlv.push(i)
                      } else if (i.code === 'jlv') {      // 净利率
                        gs.cwsj.gjbl.jlv.push(i)
                      } else if (i.code === 'jzcsyl') {   // 净资产收益率
                        gs.cwsj.gjbl.jzcsyl.push(i)
                      } else if (i.code === 'ckzzl') {    // 存货周转率
                        gs.cwsj.gjbl.ckzzl.push(i)
                      } else if (i.code === 'mgjzc') {   // 每股净资产
                        gs.cwsj.gjbl.mgjzc.push(i)
                      } else if (i.code === 'mgjyxjllje') {   // 每股经营活动产生的现金流量净额
                        gs.cwsj.gjbl.mgjyxjllje.push(i)
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.ssfw = ssfw
        this.gs = gs
        console.log(ssfw)
        console.log(gs)
        this.tab1 = condition.typ
        this.sort = condition.sort
        this.stype = condition.stype
        if (this.tab1 === 1) {
          this.page = condition.page
          this.perPage = condition.perPage
        }
        if (this.tab1 === 2) {
          this.cpage = condition.page
          this.cperPage = condition.perPage
        }
        this.getCrumbs(condition.condition)
        this.search()

      },

      parseUrlQuery (query) {
        if (query.hasOwnProperty('sd')) {
          $.ajax({
            url: apiUrl('/V1.0.0/notice/getcond'),
            method: 'post',
            dataType: 'json',
            async: false,
            data: JSON.stringify({'sd': query['sd']})
          }).done((response) => {
            if (response.status === 0) {
              let condition = response.condition
              this.common(condition)
            }
          }).fail((response) => {
            alert('请求失败')
          })
        }
      },
      customShow () {
        this.showCustom = true
      },
      /*
      * 初始化条件
      * @param {object} cond - 条件对象
      * */
      initCond (cond) {
        this.lvl1 = []
        this.lvl2 = []
        this.lvl3 = []
        this.crumbs = []
        this.curcond = cond || null
        let i = 0
        let lvl1 = []
        if (cond) {
          lvl1 = cond.ref
        } else {
          lvl1 = this.meta
        }
        for (let d of lvl1) {
          if (d.hasOwnProperty('stype')) {
            if (d.stype !== this.stype) {
              continue
            }
          }
          if (d.uniq === 1) {
            if (this.uniqMap.hasOwnProperty(d.code)) {
              continue
            }
          }
          let t = {}
          Object.assign(t, d, {'selected': false})
          this.lvl1.push(t)
          i++
        }
      },
      addCond (cond) {
        this.showCondition = true
        this.initCond(cond)
      },
      selectCond (cond) {
        if (!cond.industry) {
          for (let d of this.lvl2) {
            if (d.selected) {
              d.selected = false
              this.crumbs.splice(-1, 1)
              break
            }
          }
          for (let d of this.lvl1) {
            if (d.selected) {
              d.selected = false
              this.crumbs.splice(-1, 1)
              break
            }
          }
          cond.selected = true
          let crumb = {'name': cond.name, 'code': cond.code, 'type': cond.type, 'ref': this.lvl1, 'op': 1, 'stype': cond.stype, 'unit': cond.unit, 'uniq': cond.uniq}
          if (cond.type === 'Date' || cond.type === 'Money') {
            crumb['range'] = 1
            crumb['value'] = ''
            crumb['value1'] = ''
          }
          if (cond.type === 'Finance') {
            crumb['year'] = '2016'
            crumb['quarter'] = '年报'
            crumb['range'] = 1
            crumb['value'] = ''
            crumb['value1'] = ''
          }
          this.crumbs.push(crumb)
        }
        if (cond.hasOwnProperty('child') && cond.child.length > 0) {
          this.lvl2 = []
          for (let d of cond.child) {
            if (d.hasOwnProperty('stype')) {
              if (d.stype !== this.stype) {
                continue
              }
            }
            let t = {}
            if (cond.code === 'industry') {
              Object.assign(t, d, {'selected': false, 'industry': true})
            } else {
              Object.assign(t, d, {'selected': false})
            }
            this.lvl2.push(t)
          }
        } else {
          this.lvl2 = []
          let crumbs = []
          for (let c of this.crumbs) {
            crumbs.push(Object.assign({}, c, {'child': []}))
          }
          this.crumbs = crumbs
          let i = 0
          let len = this.crumbs.length
          for (let c of this.crumbs) {
            if (c.uniq === 1) {
              this.uniqMap[c.code] = 1
            }
            if (i + 1 < len) {
              this.crumbs[i + 1].parent = c
              c.child.push(this.crumbs[i + 1])
            }
            i++
          }
          if (!this.curcond) {
            this.condition.push(this.crumbs[0])
          } else {
            this.crumbs[0].parent = this.curcond.parent
            this.curcond.parent.child.push(this.crumbs[0])
          }
          this.showCondition = false
        }
      },
      selectChildCond (cond) {
        if (!cond.industry) {
          for (let d of this.lvl2) {
            if (d.selected) {
              d.selected = false
              this.crumbs.splice(-1, 1)
              break
            }
          }
          cond.selected = true
          let crumb = {'name': cond.name, 'code': cond.code, 'type': cond.type, 'ref': this.lvl2, 'op': 1, 'stype': cond.stype, 'unit': cond.unit, 'uniq': cond.uniq}
          if (cond.type === 'Date' || cond.type === 'Money') {
            crumb['range'] = 1
            crumb['value'] = ''
            crumb['value1'] = ''
          }
          if (cond.type === 'Finance') {
            crumb['year'] = '2016'
            crumb['quarter'] = '年报'
            crumb['range'] = 1
            crumb['value'] = ''
            crumb['value1'] = ''
          }
          this.crumbs.push(crumb)
        }
        if (cond.hasOwnProperty('child') && cond.child.length > 0) {
          this.lvl1 = this.lvl2
          this.lvl2 = []
          for (let d of cond.child) {
            if (d.hasOwnProperty('stype')) {
              if (d.stype !== this.stype) {
                continue
              }
              if (d.uniq === 1) {
                if (this.uniqMap.hasOwnProperty(d.code)) {
                  continue
                }
              }
            }
            let t = {}
            if (cond.code === 'industry') {
              Object.assign(t, d, {'selected': false, 'industry': true})
            } else {
              Object.assign(t, d, {'selected': false})
            }
            this.lvl2.push(t)
          }
        } else {
          let crumbs = []
          for (let c of this.crumbs) {
            crumbs.push(Object.assign({}, c, {'child': []}))
          }
          this.crumbs = crumbs
          let i = 0
          let len = this.crumbs.length
          for (let c of this.crumbs) {
            if (c.uniq === 1) {
              this.uniqMap[c.code] = 1
            }
            if (i + 1 < len) {
              this.crumbs[i + 1].parent = c
              c.child.push(this.crumbs[i + 1])
            }
            i++
          }
          if (!this.curcond) {
            this.condition.push(this.crumbs[0])
          } else {
            this.crumbs[0].parent = this.curcond.parent
            this.curcond.parent.child.push(this.crumbs[0])
          }
          this.showCondition = false
        }
      },
      companyDetail (d) {
        console.log(d["companyCode"])
        // $.ajax({
        //   url: apiUrl('/V1.0.0/company/detail'),
        //   method: 'post',
        //   dataType: 'json',
        //   data: JSON.stringify({'code': d['companyCode']})
        // })
        if (this.stype === 3) {
          alert('no!')
          return false
        }
        // this.$route.router.go({path: '/companyInfo', query: {'code': d['companyCode'], 'stype': this.stype}})
        window.open('/#!/companyInfo/' + '?code=' + d['companyCode'] + '&stype=' + this.stype)
      },
      selectThirdCond (cond) {
        cond.selected = true
        for (var d of this.lvl3) {
          if (d.code === cond.code) {
            return false
          }
        }
        this.lvl3.push(cond)
      },
      rmvThirdCond (idx) {
        for (let d of this.lvl2) {
          if (d.code === this.lvl3[idx].code) {
            d.selected = false
            break
          }
        }
        this.lvl3.splice(idx, 1)
      },
      confirmThirdCond () {
        if (this.curcond && (this.curcond.multi)) {
          let indus = this.curcond.value
          let selected = {}
          for (let d of indus) {
            selected[d.code] = 1
          }
          for (var d of this.lvl3) {
            if (!selected.hasOwnProperty(d.code)) {
              this.curcond.value.push({'name': d.name, 'code': d.code})
            }
          }
          this.showCondition = false
          return
        }
        let crumb = {'multi': 1, 'type': 'Value', 'op': 2, 'value': [], 'ref': this.lvl1}
        for (let d of this.lvl3) {
          crumb['value'].push({'name': d.name, 'code': d.code})
        }
        this.crumbs.push(crumb)
        let crumbs = []
        for (let c of this.crumbs) {
          crumbs.push(Object.assign({}, c, {'child': []}))
        }
        this.crumbs = crumbs
        let i = 0
        let len = this.crumbs.length
        for (let c of this.crumbs) {
          if (c.uniq === 1) {
            this.uniqMap[c.code] = 1
          }
          if (i + 1 < len) {
            this.crumbs[i + 1].parent = c
            c.child.push(this.crumbs[i + 1])
          }
          i++
        }
        if (!this.curcond) {
          this.condition.push(this.crumbs[0])
        } else {
          this.crumbs[0].parent = this.curcond.parent
          this.curcond.parent.child.push(this.crumbs[0])
        }
        this.showCondition = false
      },
      addCondition (type, obj) {
        if (type === 'gglx' && this.gglxList[obj.code]) {
          for (let item of this.condition) {
            for (let i of item.child) {
              for (let j in i.value) {
                if (i.value[j].code === obj.code) {
                  i.value.splice(j, 1)
                  if (i.value.length === 0) {
                    let idx = i.parent.child.indexOf(i)
                    this.delChild(i.parent.child, idx)
                  }
                  break
                }
              }
            }
          }
          return false
        }
        if (type === 'ggbq' && this.ggbqList[obj.code]) {
          for (let item of this.condition) {
            for (let i of item.child) {
              for (let j in i.value) {
                if (i.value[j].code === obj.code) {
                  i.value.splice(j, 1)
                  if (i.value.length === 0) {
                    let idx = i.parent.child.indexOf(i)
                    this.delChild(i.parent.child, idx)
                  }
                  break
                }
              }
            }
          }
          return false
        }
        let idx = 0
        for (let d of this.condition) {
          if (d.code === type) {
            this.condition.splice(idx, 1)
            break
          }
          idx++
        }
        console.log(obj)
        console.log(this.condition)
        this.initCond()
        this.selectCond(this.metaMap[type])
        this.selectThirdCond(this.metaMap[obj.code])
        this.confirmThirdCond()
        if (this.searched) {
          this.go()
        }
      },
      delChild (arr, idx) {
        if (idx < 0) {
          idx = 0
        }
        let code = arr[idx].code
        if (this.uniqMap.hasOwnProperty(code)) {
          delete this.uniqMap[code]
        }
        arr.splice(idx, 1)
      },
      backCond () {
        if (this.crumbs.length > 1) {
          this.crumbs.splice(-1, 1)
          if (this.crumbs.length > 1) {
            this.lvl1 = this.crumbs.slice(-2)[0].ref
            this.lvl2 = this.crumbs.slice(-1)[0].ref
          } else {
            this.lvl2 = this.lvl1
            this.lvl1 = this.crumbs.slice(-1)[0].ref
          }
        }
      },
      showOp (event) {
        let el = $(event.target)
        el.next().show()
      },
      selOp (event, val) {
        let el = $(event.target)
        this.op = val
        el.parent().parent().parent().hide()
      },
      selStype (event, val) {
        let el = $(event.target)
        this.stype = val
        let len = this.condition.length
        for (let i = 0; i < len; i++) {
          let d = this.condition[i]
          if (d.stype && d.stype !== this.stype) {
            this.condition.splice(i, 1)
          }
        }
        el.parent().parent().parent().hide()
      },
      itemChecked (idx) {
        let checked = !this.items[idx].checked
        this.items[idx].checked = checked
        if (checked) {
          this.checkedCount++
        } else {
          this.checkedCount--
        }
      },
      /**
       * 全选/全不选
       * */
      itemCheckAll () {
        let checked = !this.checkedAll
        for (let item of this.items) {
          item.checked = checked
        }
        this.checkedAll = checked
        if (checked) {
          this.checkedCount = this.items.length
        } else {
          this.checkedCount = 0
        }
      },
      /**
       * 取消掉所有选中项
       * */
      clearChecked () {
        this.checkedAll = true
        this.itemCheckAll()
      },
      /**
       * 搜索
       * */
      go (page) {
        this.page = page || 1
        this.clearChecked()
        this.search()
      },
      /**
       * 清空
       * */
      clear () {
        this.condition = []
        this.crumbs = []
        this.uniqMap = {}
      },
      analyze () {
        let query = this.genQuery()
        let reqUrl = ''
        if (this.stype === 2) {
          reqUrl = apiUrl('/V1.0.0/notice/advanalyzen3b')
        } else {
          reqUrl = apiUrl('/V1.0.0/notice/advanalyze')
        }
        $.ajax({
          url: reqUrl,
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          if (response.status === 0) {
            this.company = response.agg.company
            this.related_company = response.agg.related_company
            this.related_name = response.agg.related_name
            if (response.agg.type) {
              this.aggTypes = []
              for (let agg of response.agg.type) {
                this.aggTypes.push({'code': agg.key, 'name': agg.key, 'count': agg.doc_count})
              }
            }
            if (response.agg.labels) {
              this.aggLabels = []
              for (let agg of response.agg.labels) {
                this.aggLabels.push({'code': agg.key, 'name': agg.key, 'count': agg.doc_count})
              }
            }
          } else if (response.status === 502) {
            console.log('很抱歉，请求超时请重新搜索')
          }
        }).fail((response) => {
          console.log('请求失败')
        })
      },
      getList () {
        this.gglxList = {}
        this.ggbqList = {}
        for (let item of this.condition) {
          if (item.code && item.code === 'gglx') {
            for (let i of item.child) {
              for (let j of i.value) {
                let tmp = {}
                tmp[j.code] = j.name
                this.gglxList = Object.assign({}, this.gglxList, tmp)
              }
            }
          }
          if (item.code && item.code === 'ggbq') {
            for (let i of item.child) {
              for (let j of i.value) {
                let tmp = {}
                tmp[j.code] = j.name
                this.ggbqList = Object.assign({}, this.ggbqList, tmp)
              }
            }
          }
        }
      },
      genQuery () {
        let query = {}
        this.querycond = []
        this.genCondition(this.querycond, this.condition)
        query['typ'] = this.tab1
        query['condition'] = this.querycond
        query['stype'] = this.stype
        if (this.tab1 === 1) {
          query['perPage'] = this.perPage
          query['page'] = this.page
        }
        if (this.tab1 === 2) {
          query['perPage'] = this.cperPage
          query['page'] = this.cpage
        }
        query['sort'] = this.sort
        if (this.ai === 1) {
          query['ai'] = this.ai
        }
        return query
      },
      genCondition (querycond, cond) {
        for (let d of cond) {
          let newcond = {'name': d.name, 'code': d.code, 'type': d.type, 'op': d.op}
          if (d.hasOwnProperty('range')) {
            newcond['range'] = d.range
          }
          if (d.hasOwnProperty('value')) {
            newcond['value'] = d.value
          }
          if (d.hasOwnProperty('value1')) {
            newcond['value1'] = d.value1
          }
          if (d.hasOwnProperty('year')) {
            newcond['year'] = d.year
          }
          if (d.hasOwnProperty('quarter')) {
            newcond['quarter'] = d.quarter
          }
          if (d.hasOwnProperty('multi')) {
            newcond['multi'] = d.multi
          }
          newcond['child'] = []
          if (d.child.length > 0) {
            this.genCondition(newcond.child, d.child)
          }
          querycond.push(newcond)
        }
      },
      gettags () {
        $.ajax({
          url: apiUrl('/V1.0.0/user/taglist'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify({'scope': 2})
        }).done((response) => {
          if (response.status === 0) {
            let tags = response.data
            for (let d of tags) {
              d.showDel = false
            }
            this.tags = tags
            this.tags1 = []
            this.tags2 = []
            this.tags3 = []
            for (let d of this.tags) {
              if (d.cat === 1) {
                this.tags1.push(d)
              }
              if (d.cat === 2) {
                this.tags2.push(d)
              }
              if (d.cat === 3) {
                this.tags3.push(d)
              }
            }
          }
        }).fail((response) => {
          alert('请求失败')
        })
      },
      saveTag () {
        let data = JSON.stringify(this.genQuery())
        let query = {'name': this.tagname, 'data': data, 'typ': this.stype, 'cat': this.tab1, 'scope': 2}
        this.loading = true
        $.ajax({
          url: apiUrl('/V1.0.0/user/savetag'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          if (response.status === 0) {
            alert('保存成功')
            this.showModalTag = false
            this.tagname = ''
            this.gettags()
          }
        }).fail((response) => {
          alert('请求失败')
        })
      },
      /**
       * 点击标签搜索
       * */
      searchByTag (tagid) {
        $.ajax({
          url: apiUrl('/V1.0.0/user/gettag'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify({'id': tagid})
        }).done((response) => {
          if (response.status === 0) {
            console.log('2333')
            this.showTag = false
            let condition = response.data
            this.tab1 = condition.typ
            this.stype = condition.stype
            this.sort = condition.sort
            if (this.tab1 === 1) {
              this.page = condition.page
              this.perPage = condition.perPage
            }
            if (this.tab1 === 2) {
              this.companyitems = []
              this.cpage = condition.page
              this.cperPage = condition.perPage
            }

            // this.getCrumbs(condition.condition)
            // this.search()
            this.common(condition)
          }
        }).fail((response) => {
          alert('请求失败')
        })
      },
      /**
       * 删除标签
       * */
      delTag (tagid) {
        let that = this
        confirm('确定删除此标签?', function () {
          $.ajax({
            url: apiUrl('/V1.0.0/user/deltag'),
            method: 'post',
            dataType: 'json',
            data: JSON.stringify({'id': tagid})
          }).done((response) => {
            if (response.status === 0) {
              that.gettags()
            }
          }).fail((response) => {
            alert('请求失败')
          })
        })
      },
      /**
       * 设置css缩进
       * */
      indentChild (code) {
        let len = code.split('.').length - 2
        return {'padding-left': len * 10 + 'px'}
      },
      hideDropDown (event) {
        if (event.target.className !== 'fz1') {
          $('.fz2').hide()
        }
        return false
      },
      batchDownload () {
        this.advdownloading = true
        let query = {'paths': []}
        for (let item of this.items) {
          if (item.checked) {
            query['paths'].push({'filename': item.filename, 'title': item.title})
          }
        }
        $.ajax({
          url: apiUrl('/V1.0.0/file/batch'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.advdownloading = false
          if (response.status === 0) {
            let zipfile = response.zipfile
            downloadURL('http://114.215.71.108:9010/' + zipfile)
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.advdownloading = false
          alert('请求失败')
        })
      },
      searchSample (id) {
        let idx = id - 1
        let condition = this.samples[idx]
        this.tab1 = condition.typ
        this.stype = condition.stype
        this.sort = condition.sort
        if (this.tab1 === 1) {
          this.page = condition.page
          this.perPage = condition.perPage
        }
        if (this.tab1 === 2) {
          this.cpage = condition.page
          this.cperPage = condition.perPage
        }
        this.getCrumbs(condition.condition)
        this.search()
      },
      addChildCond (cond) {
        this.curcond = cond
        this.showCondition = true
        this.lvl1 = []
        this.lvl2 = []
        this.lvl3 = []
        this.crumbs = []
        let i = 0
        let lvl2 = []
        let pcode = cond.parent.code
        if (this.metaMap.hasOwnProperty(pcode)) {
          lvl2 = this.metaMap[pcode].child
          for (let d of lvl2) {
            if (d.hasOwnProperty('stype')) {
              if (d.stype !== this.stype) {
                continue
              }
            }
            if (d.uniq === 1) {
              if (this.uniqMap.hasOwnProperty(d.code)) {
                continue
              }
            }
            let t = {}
            Object.assign(t, d, {'selected': false})
            this.lvl2.push(t)
            i++
          }
        }
      },
      downloadUrl (item) {
        return 'http://114.215.71.108:9005/file/download?path=' + item.filename + '&title=' + item.title
      },
      goview: function (item) {
        let url = this.viewUrl(item)
        if (document.cookie.indexOf('embed=1') < 0) {
          window.open(url)
        } else {
          if (this.stype === 2 ) {
            window.location.href = url
          } else {
            window.open(url)
          }
          // window.open(url)
        }
      },
      fileIcon (fileext) {
        if (fileext === 'pdf') {
          return 'pdf-icon'
        }
        if (fileext === 'docx' || fileext === 'doc') {
          return 'dov-icon'
        }
        if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
          return 'html-icon'
        }
        if (fileext === 'xls' || fileext === 'xlsx') {
          return 'xsl-icon'
        }
      },
      /**
       * 到处文件
       */
      exportFile () {
        let query = this.genQuery()
        query.export = 1
        let reqUrl = ''
        if (this.stype === 2) {
          reqUrl = apiUrl('/V1.0.0/notice/advsearchn3b')
        } else {
          reqUrl = apiUrl('/V1.0.0/notice/advsearch')
        }
        $.ajax({
          url: reqUrl,
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          if (response.status === 0) {
            let exportfilepath = response.url
//          window.open(exportfilepath)
            this.downloadEFile(exportfilepath)
          } else if (response.status === 502) {
            alert('很抱歉，请求超时请重新搜索')
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      downloadEFile (url, name) {
        var link = document.createElement("a");
        link.download = name;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      viewUrl: function (item, params) {
        console.log(params)
        if (item.viewtype === 1) {
          let tcode = ''
          if (item.pid) {
            return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid
          } else {
            return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid
          }
        }
        if (item.viewtype === 2) {
          return item.viewurl
        }
        if (item.viewtype === 3) {
          return item.downloadurl
        }
      },
      qaViewUrl (item, params) {
        if (item.viewtype === 1) {
          let tcode = ''
          return '/#!/qaview/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid
        }
        if (item.viewtype === 2) {
          return item.viewurl
        }
        if (item.viewtype === 3) {
          return item.downloadurl
        }
      },
      isEmpty (obj) {
        // for (var o of obj) {
        //   if (o.length !== 0) {
        //     return false
        //   }
        // }
        // return true
        for (var i in obj) {
          if (obj[i].length !== 0) {
            console.log('false');
            return false
          }
        }
        console.log('true');
        return true
      }
    },
    computed: {
      totalPage () {
        if (this.tab1 === 1) {
          let totalPage = Math.ceil(this.total / this.perPage)
          return totalPage > 20 ? 20 : totalPage
        }
        if (this.tab1 === 2) {
          let totalPage = Math.ceil(this.ctotal1 / this.cperPage)
          return totalPage
        }
      },
      indexs () {
        let page = this.page
        if (this.tab1 === 2) {
          page = this.cpage
        }
        let left = 1
        let right = this.totalPage
        let ar = []
        if (this.totalPage >= 11) {
          if (page > 5 && page < this.totalPage - 4) {
            left = page - 5
            right = page + 4
          } else {
            if (page <= 5) {
              left = 1
              right = 10
            } else {
              right = this.totalPage
              left = page - 9
            }
          }
        }
        while (left <= right) {
          ar.push(left)
          left++
        }
        return ar
      }
    },
    watch: {
      'condition': {
        handler: function (val, oldVal) {
          this.getList()
        },
        deep: true
      }
    },
    filters: {
      'opname' (val) {
        if (val === 1) {
          return '含所有'
        }
        if (val === 2) {
          return '含任意'
        }
        if (val === 3) {
          return '不含'
        }
        return '包含全部'
      },
      'stypename' (val) {
        if (val === 1) {
          return 'A股'
        }
        if (val === 2) {
          return '新三板'
        }
        if (val === 3) {
          return '债券'
        }
        return 'A股'
      },
      'sortname' (val) {
        if (val === 1) {
          return '按相关性排序'
        }
        if (val === 2) {
          return '按时间排序'
        }
        return '按相关性排序'
      },
      formatTypeName (param) {
        if (param === 1) {
          return 'A股'
        }
        if (param === 2) {
          return '新三板'
        }
        if (param === 3) {
          return '债券'
        }
        if (param === 5) {
          return '问题库'
        }
        if (param === 6) {
          return '港股'
        }
      },
      formatKeywords (param) {
        if (param.length > 10) {
          return param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 10) + '...'
        } else {
          return param
        }
      },
      // 格式化搜索范围
      formatSSFW (param) {
        if (param === 1) {
          return '含所有'
        }
        if (param === 3) {
          return '不含'
        }
        if (param === 2) {
          return '含任意'
        }
      },
      // 格式化公司基本信息
      formatCompanyBaseInfo (param) {
        if (param.name === '注册资本') {
          if (param.range === 1) {
            return '小于'
          }
          if (param.range === 2) {
            return '大于'
          }
          if (param.range === 3) {
            return '在之间'
          }
        } else if (param.name === '成立日期') {
          if (param.op === 1) {
            return '早于'
          }
          if (param.op === 2) {
            return '晚于'
          }
          if (param.op === 3) {
            return '在期间'
          }
        } else if (param.name === '地区' || param.name === '行业类型') {
          if (param.child[0].op === 1) {
            return '含所有'
          }
          if (param.child[0].op === 2) {
            return '含任意'
          }
          if (param.child[0].op === 3) {
            return '不含'
          }
        } else {
          if (param.op === 1) {
            return '含所有'
          }
          if (param.op === 2) {
            return '含任意'
          }
          if (param.op === 3) {
            return '不含'
          }
        }
      },
      formatRangeToName (param) {
        if (param === 1) {
          return '小于'
        }
        if (param === 2) {
          return '大于'
        }
        if (param === 3) {
          return '在之间'
        }
      },
      formatNumber (z) {
        // return  Number(param).toLocaleString('en-US')
        if (!z) {
          return z
        } else {
          let num = z.toString()
          let normdata = ''
          if (num.indexOf('.') !== -1) {
            normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
              return $1 + ","
            })

          } else {
            normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function($0, $1) {
              return $1 + ","
            })
          }
          if (normdata.indexOf('.') >= 0) {
            let arr = normdata.split('.')
            if (arr[1].length < 2) {
              return normdata + '0'
            } else {
              return normdata.substr(0, normdata.indexOf('.') + 3)
            }
            // return arr[0] + '.' + arr[1]
          } else {
            return normdata
          }
        }
      },
      formatTab1 (param) {
        if (param === 1) {
          return '公告'
        }
        if (param === 2) {
          return '公司'
        }
      }
    }
  }
</script>

<style scoped>
  .loading_gif {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: 0;
    z-index: 2999;
    background-color: rgba(0, 0, 0, .7);
  }

  .loading_gif img {
    margin-top: 48%;
  }

  .small-delete {
    display: block;
    width: 17px;
    height: 20px;
    float: right;
    margin-right: 12px;
    background-image: url("../../../static/images/icon-delete.svg");
    background-size: cover;
    margin-top: 4px;
  }

  .blue {
    font-size: 14px;
    font-weight: 700;
  }
  .text-a {
    font-size: 14px;
  }

  p {
    text-indent: 0;
  }

  .f3{
    float: right;
    width: 0.55rem;
    height: 0.32rem;
    margin-right: 0.5rem;
    margin-top: 0.98rem;
    color: #1E88E5;
    font-size: 0.8rem;
    background-image: url(/static/images/expand-more-a.png);
    background-size: 100%;
  }
  /* 加载更多 */

  .more,
  .more_top {
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
  }
  .pull_icon,
  .pull_icon_top {
    width: 25px;
    height: 25px;
    /*background-image: url('../images/pull.png');*/
    /*background-image: url('../../../static/images/pull.png');*/
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
    transition: all .5s;
  }
  .more span,
  .more_top span {
    padding-left: .5rem;
  }


  .more .flip,
  .more_top .flip {
    transform: rotate(180deg);
  }
  .loading{
    /*background-image: url('../images/loading.png');*/
    background-image: url('../../../static/images/loading.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
  }
  .more .loading,
  .more_top .loading {
    -webkit-transform: rotate(0deg) translateZ(0);
    -webkit-transition-duration: 0;
    -webkit-animation-name: loading;
    -webkit-animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
  }

  @-webkit-keyframes loading {
    from {
      -webkit-transform: rotate(0deg) translateZ(0);
    }
    to {
      -webkit-transform: rotate(360deg) translateZ(0);
    }
  }
  .search-result-list:nth-child(1) {
    margin-top: .5rem;
  }

/*  .Screen-criteria-head .fr {
    width: 0.6rem;
    height: 0.6rem;
    margin-top: 0.8rem;
  }*/

  .Screen-criteria-head span.close {
    background-image: url("../../../static/images/icon-slidedown.svg") !important;
    background-size: cover;
  }

  .Screen-criteria-head span.open {
    background-image: url("../../../static/images/icon-slideup.svg") !important;
    background-size: cover;
  }

  /*自定义分享日期*/
  .search-date-custom .time .l,
  .search-date-custom .time .r {
    /*display: inline-block;*/
    width: 24%;
  }

  .cov-vue-date {
    width: 100%;
  }

  .datepickbox {
    width: 100%;
  }

  .datepickbox input {
    width: 100% !important;
    padding: 0px !important;
  }

  .cov-datepicker {
    border: none;
  }

  /*-------------------------------------------搜索页 --------------------------------------*/
  .cov-date-body {
    width: 80% !important;
    margin-left: -7.4% !important;
  }

  .loading_gif {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: 0;
    z-index: 2999;
    background-color: rgba(0, 0, 0, .7);
  }

  .loading_gif img {
    margin-top: 48%;
  }

  .date-slide-menu {
    background: #FFFFFF;
    /*width: 13rem;*/
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    border: 1px solid #e0dddd;
  }

  .select-name {
    float: left;
    width: 90%;
  }
  .arrow-img {
    float: right;
    width: 25px;
    height: 25px;
  }

  .arrow-img img {
    max-width: 100%;
  }

  .home-nav-app > .lanmu {
    top: 1.2rem;
  }
  .el-checkbox {
    width: 100%;
  }

  .el-checkbox .qicon {
    float: right;
    margin-right: 1.2rem;
    background-size: cover;
    margin-top: 6px;
    height: .6rem;
    width: .8rem;
  }

  .el-checkbox .qicon.close {
    background: url("../../../static/images/icon-slidedown.svg");
    background-size: cover;
  }

  .el-checkbox .qicon.open {
    background: url("../../../static/images/icon-slideup.svg");
    background-size: cover;
  }

  .dio .second {
    text-indent: .5rem;
  }

  .release-date .date-menu.close,
  .search-input .date-menu.close {
    display: none;
  }

  .release-date .date-menu.open,
  .search-input .date-menu.open {
    display: block;
  }

  /*发布日期*/
  .r cov-vue-date .datepickbox input {
    text-align: right;
  }

  .Release-date .time .r {
    width: 5rem;
  }
  /*------------------------------------------- / 搜索页 ----------------------------------*/
  .modal {
    display: block;
  }

  .search-company-box {
    margin: 0;
    width: 100%;
  }

  .company-detail-wrap {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1000;
    background-color: #f5f5f5;
  }
  .con-search>ul>li li {
    padding-left: .5rem;
  }
</style>




/** WEBPACK FOOTER **
 ** AdvSearch.vue?e2f5f594
 **/